webpackJsonp([1],{

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mock = __webpack_require__(339);

var _mock2 = _interopRequireDefault(_mock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _mock2.default;

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(690);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(688);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(689);

var _Home2 = _interopRequireDefault(_Home);

var _Main = __webpack_require__(691);

var _Main2 = _interopRequireDefault(_Main);

var _Table = __webpack_require__(698);

var _Table2 = _interopRequireDefault(_Table);

var _A = __webpack_require__(693);

var _A2 = _interopRequireDefault(_A);

var _B = __webpack_require__(694);

var _B2 = _interopRequireDefault(_B);

var _C = __webpack_require__(695);

var _C2 = _interopRequireDefault(_C);

var _D = __webpack_require__(696);

var _D2 = _interopRequireDefault(_D);

var _Form = __webpack_require__(697);

var _Form2 = _interopRequireDefault(_Form);

var _user = __webpack_require__(699);

var _user2 = _interopRequireDefault(_user);

var _Page = __webpack_require__(700);

var _Page2 = _interopRequireDefault(_Page);

var _Page3 = __webpack_require__(701);

var _Page4 = _interopRequireDefault(_Page3);

var _Page5 = __webpack_require__(702);

var _Page6 = _interopRequireDefault(_Page5);

var _echarts = __webpack_require__(692);

var _echarts2 = _interopRequireDefault(_echarts);

var _mainTable = __webpack_require__(703);

var _mainTable2 = _interopRequireDefault(_mainTable);

var _table = __webpack_require__(704);

var _table2 = _interopRequireDefault(_table);

var _table3 = __webpack_require__(705);

var _table4 = _interopRequireDefault(_table3);

var _table5 = __webpack_require__(706);

var _table6 = _interopRequireDefault(_table5);

var _table7 = __webpack_require__(707);

var _table8 = _interopRequireDefault(_table7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '规则管理与原始数据',
    iconCls: 'el-icon-message',
    children: [{ path: '/main', component: _Main2.default, name: '主页', hidden: true }, { path: '/A', component: _A2.default, name: '销项涉税规则维护' }, { path: '/B', component: _B2.default, name: '涉税规则与计税要素匹配' }, { path: '/C', component: _C2.default, name: '销售交易接口表' }, { path: '/D', component: _D2.default, name: '销售交易匹配结果表' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '销项管理',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/E', component: _Page2.default, name: '销项发票取数台账' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '未开票收入汇总底稿',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/F', component: _Page2.default, name: '已发生纳税义务但未开票收入台账' }, { path: '/G', component: _Page2.default, name: '前期已申报当期开票收入台账' }, { path: '/H', component: _Page2.default, name: '视同销售台账' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '一般计税收入汇总底稿',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/j', component: _Page2.default, name: '纳税检查调整一般计税收入台账' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '税收优惠台账',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/k', component: _Page2.default, name: '免税项目台账' }, { path: '/l', component: _Page2.default, name: '金融商品转让台账' }, { path: '/z', component: _Page2.default, name: '减税明细管理台账' }, { path: '/x', component: _Page2.default, name: '免税明细管理台账' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '进项税管理',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/c', component: _Page2.default, name: '增值税专用发票台账' }, { path: '/v', component: _Page2.default, name: '海关进口增值税专用缴款书台账' }, { path: '/b', component: _Page2.default, name: '道路、桥、闸通行费抵扣凭证台账' }, { path: '/n', component: _Page2.default, name: '代扣代缴税收缴款凭证台账' }, { path: '/m', component: _Page2.default, name: '农产品收购发票或销售发票台账' }, { path: '/q', component: _Page2.default, name: '加计扣除农产品进项税额台账' }, { path: '/w', component: _Page2.default, name: '购建不动产专用发票' }, { path: '/e', component: _Page2.default, name: '从不可抵扣项目改为可抵扣项目台账（不含不动产）' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '进项税转出管理',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/r', component: _Page2.default, name: '进项税额转出汇总底稿', children: [{ path: '/t', component: _Page2.default, name: '用于集体福利、个人消费台账' }, { path: '/y', component: _Page2.default, name: '非正常损失进项转出台账' }, { path: '/u', component: _Page2.default, name: '免税项目进项转出台账' }, { path: '/i', component: _Page2.default, name: '简易计税方法进项转出台账' }, { path: '/o', component: _Page2.default, name: '纳税检查调减进项税额台账' }, { path: '/aa', component: _Page2.default, name: '红字专用发票信息表注明的进项税额台账' }, { path: '/ss', component: _Page2.default, name: '其他应作进项税额转出的情形台账' }] }, { path: '/dd', component: _Page2.default, name: '从可抵扣项目改为不可抵扣项目汇总底稿（不含不动产）', children: [{ path: '/ff', component: _Page2.default, name: '从可抵扣项目改为不可抵扣项目台账（不含不动产）' }] }, { path: '/gg', component: _Page2.default, name: '从可抵扣项目改为不可抵扣项目汇总底稿（不动产）', children: [{ path: '/hh', component: _Page2.default, name: '从可抵扣项目改为不可抵扣项目台账（不动产）' }] }]
}, {
    path: '/',
    component: _Home2.default,
    name: '税额抵减管理',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/qq', component: _Page2.default, name: '增值税税控系统专用设备费台账' }, { path: '/ww', component: _Page2.default, name: '增值税税控系统技术维护费台账' }, { path: '/ee', component: _Page2.default, name: '分支机构预征缴纳税款台账' }, { path: '/rr', component: _Page2.default, name: '建筑服务预征缴纳税款台账' }, { path: '/tt', component: _Page2.default, name: '销售不动产预征缴纳税款台账' }, { path: '/yy', component: _Page2.default, name: '出租不动产预征缴纳税款台账' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '不动产分期抵扣管理',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/zz', component: _Page2.default, name: '购建不动产专用发票' }, { path: '/xx', component: _Page2.default, name: '销售分期抵扣中的不动产台账' }, { path: '/cc', component: _Page2.default, name: '从不可抵扣项目改为可抵扣项目台账（不动产）' }, { path: '/vv', component: _Page2.default, name: '前期购入并全额抵扣货物、服务转用于不动产台账' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '代扣代缴业务管理',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/vvv', component: _Page2.default, name: '扣缴义务人信息维护' }, { path: '/ccc', component: _Page2.default, name: '非居民企业信息维护' }, { path: '/xxx', component: _Page2.default, name: '非贸付汇合同基本信息管理' }, { path: '/zzz', component: _Page2.default, name: '代扣代缴支付台账管理' }, { path: '/aaa', component: _Page2.default, name: '代缴代缴申报管理' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '纳税申报',
    iconCls: 'fa fa-bar-chart',
    children: [{ path: '/t1', component: _mainTable2.default, name: '主表' }, { path: '/t2', component: _table2.default, name: '附表一' }, { path: '/t3', component: _table4.default, name: '附表二' }, { path: '/t4', component: _table6.default, name: '附表三' }, { path: '/t5', component: _table8.default, name: '附表四' }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(106);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(340);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(341);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(662)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(708),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			sysName: 'VMS',
			collapsed: true,
			sysUserName: '',
			sysUserAvatar: '',
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(a, b) {},

		logout: function logout() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {}).then(function () {
				sessionStorage.removeItem('user');
				_this.$router.push('/login');
			}).catch(function () {});
		},

		collapse: function collapse() {
			this.collapsed = !this.collapsed;
		},
		showMenu: function showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		}
	},
	mounted: function mounted() {
		var user = sessionStorage.getItem('user');
		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.name || '';
			this.sysUserAvatar = user.avatar || '';
		}
	}
};

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(164);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: 'admin',
        checkPass: '123456'
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;
          var loginParams = { username: _this2.ruleForm2.account, password: _this2.ruleForm2.checkPass };
          (0, _api.requestLogin)(loginParams).then(function (data) {
            _this2.logining = false;
            var msg = data.msg,
                code = data.code,
                user = data.user;

            if (code !== 200) {
              _this2.$message({
                message: msg,
                type: 'error'
              });
            } else {
              sessionStorage.setItem('user', (0, _stringify2.default)(user));
              _this2.$router.push({ path: '/A' });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _echarts = __webpack_require__(391);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            chartColumn: null,
            chartBar: null,
            chartLine: null,
            chartPie: null
        };
    },


    methods: {
        drawColumnChart: function drawColumnChart() {
            this.chartColumn = _echarts2.default.init(document.getElementById('chartColumn'));
            this.chartColumn.setOption({
                title: { text: 'Column Chart' },
                tooltip: {},
                xAxis: {
                    data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
                },
                yAxis: {},
                series: [{
                    name: '销量',
                    type: 'bar',
                    data: [5, 20, 36, 10, 10, 20]
                }]
            });
        },
        drawBarChart: function drawBarChart() {
            this.chartBar = _echarts2.default.init(document.getElementById('chartBar'));
            this.chartBar.setOption({
                title: {
                    text: 'Bar Chart',
                    subtext: '数据来自网络'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['2011年', '2012年']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
                },
                series: [{
                    name: '2011年',
                    type: 'bar',
                    data: [18203, 23489, 29034, 104970, 131744, 630230]
                }, {
                    name: '2012年',
                    type: 'bar',
                    data: [19325, 23438, 31000, 121594, 134141, 681807]
                }]
            });
        },
        drawLineChart: function drawLineChart() {
            this.chartLine = _echarts2.default.init(document.getElementById('chartLine'));
            this.chartLine.setOption({
                title: {
                    text: 'Line Chart'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['邮件营销', '联盟广告', '搜索引擎']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name: '邮件营销',
                    type: 'line',
                    stack: '总量',
                    data: [120, 132, 101, 134, 90, 230, 210]
                }, {
                    name: '联盟广告',
                    type: 'line',
                    stack: '总量',
                    data: [220, 182, 191, 234, 290, 330, 310]
                }, {
                    name: '搜索引擎',
                    type: 'line',
                    stack: '总量',
                    data: [820, 932, 901, 934, 1290, 1330, 1320]
                }]
            });
        },
        drawPieChart: function drawPieChart() {
            this.chartPie = _echarts2.default.init(document.getElementById('chartPie'));
            this.chartPie.setOption({
                title: {
                    text: 'Pie Chart',
                    subtext: '纯属虚构',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                },
                series: [{
                    name: '访问来源',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: [{ value: 335, name: '直接访问' }, { value: 310, name: '邮件营销' }, { value: 234, name: '联盟广告' }, { value: 135, name: '视频广告' }, { value: 1548, name: '搜索引擎' }],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            });
        },
        drawCharts: function drawCharts() {
            this.drawColumnChart();
            this.drawBarChart();
            this.drawLineChart();
            this.drawPieChart();
        }
    },

    mounted: function mounted() {
        this.drawCharts();
    },
    updated: function updated() {
        this.drawCharts();
    }
};

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(62);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      aData: [],
      filters: {
        name: ""
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      editLoading: false
    };
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      var para = {
        page: this.page,
        name: this.filters.name
      };
      this.listLoading = true;

      (0, _api.getA)(para).then(function (res) {
        _this.total = res.data.total;
        _this.aData = res.data.list;
        _this.listLoading = false;
      });
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      }).then(function () {
        debugger;
        _this2.listLoading = true;
        var para = { id: row.id };
        (0, _api.removeA)(para).then(function (res) {
          _this2.listLoading = false;
          debugger;
          _this2.$message({
            message: res.data.msg,
            type: "success"
          });
          _this2.loadData();
        });
      }).catch(function () {});
    },
    handleAdd: function handleAdd() {
      this.aData.splice(0, 0, { id: "\u65B0\u589E", state: "new" });
    },
    handleSave: function handleSave() {
      var _this3 = this;

      (0, _api.saveA)(this.aData).then(function (res) {
        _this3.$message({
          message: res.data.msg,
          type: "success"
        });
      });
    },
    getIdColor: function getIdColor(state) {
      var color = 'black';
      switch (state) {
        case 'new':
          color = 'red';
          break;
        case 'modify':
          color = 'yellow';
          break;
        default:
          break;
      }
      return color;
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(62);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      aData: [],
      filters: {
        name: ""
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      editLoading: false
    };
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      var para = {
        page: this.page,
        name: this.filters.name
      };
      this.listLoading = true;

      (0, _api.getA)(para).then(function (res) {
        _this.total = res.data.total;
        _this.aData = res.data.list;
        _this.listLoading = false;
      });
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      }).then(function () {
        _this2.listLoading = true;

        var para = { id: row.id };
        (0, _api.removeA)(para).then(function (res) {
          _this2.listLoading = false;

          _this2.$message({
            message: "删除成功",
            type: "success"
          });
          _this2.loadData();
        });
      }).catch(function () {});
    },
    handleAdd: function handleAdd() {}
  },
  mounted: function mounted() {
    this.loadData();
  }
};

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(62);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      aData: [],
      filters: {
        name: ""
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      editLoading: false
    };
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      var para = {
        page: this.page,
        name: this.filters.name
      };
      this.listLoading = true;

      (0, _api.getA)(para).then(function (res) {
        _this.total = res.data.total;
        _this.aData = res.data.list;
        _this.listLoading = false;
      });
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      }).then(function () {
        _this2.listLoading = true;

        var para = { id: row.id };
        (0, _api.removeA)(para).then(function (res) {
          _this2.listLoading = false;

          _this2.$message({
            message: "删除成功",
            type: "success"
          });
          _this2.loadData();
        });
      }).catch(function () {});
    },
    handleAdd: function handleAdd() {}
  },
  mounted: function mounted() {
    this.loadData();
  }
};

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(62);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      aData: [],
      filters: {
        name: ""
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      editLoading: false
    };
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      var para = {
        page: this.page,
        name: this.filters.name
      };
      this.listLoading = true;

      (0, _api.getA)(para).then(function (res) {
        _this.total = res.data.total;
        _this.aData = res.data.list;
        _this.listLoading = false;
      });
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      }).then(function () {
        _this2.listLoading = true;

        var para = { id: row.id };
        (0, _api.removeA)(para).then(function (res) {
          _this2.listLoading = false;

          _this2.$message({
            message: "删除成功",
            type: "success"
          });
          _this2.loadData();
        });
      }).catch(function () {});
    },
    handleAdd: function handleAdd() {}
  },
  mounted: function mounted() {
    this.loadData();
  }
};

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		}
	}
};

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(165);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(62);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			users: [],
			total: 0,
			page: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			addForm: {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			}

		};
	},

	methods: {
		formatSex: function formatSex(row, column) {
			return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getUsers();
		},
		getUsers: function getUsers() {
			var _this = this;

			var para = {
				page: this.page,
				name: this.filters.name
			};
			this.listLoading = true;

			(0, _api.getUserListPage)(para).then(function (res) {
				_this.total = res.data.total;
				_this.users = res.data.users;
				_this.listLoading = false;
			});
		},

		handleDel: function handleDel(index, row) {
			var _this2 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(function () {
				_this2.listLoading = true;

				var para = { id: row.id };
				(0, _api.removeUser)(para).then(function (res) {
					_this2.listLoading = false;

					_this2.$message({
						message: '删除成功',
						type: 'success'
					});
					_this2.getUsers();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this3.editLoading = true;

						var para = (0, _assign2.default)({}, _this3.editForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.editUser)(para).then(function (res) {
							_this3.editLoading = false;

							_this3.$message({
								message: '提交成功',
								type: 'success'
							});
							_this3.$refs['editForm'].resetFields();
							_this3.editFormVisible = false;
							_this3.getUsers();
						});
					});
				}
			});
		},

		addSubmit: function addSubmit() {
			var _this4 = this;

			this.$refs.addForm.validate(function (valid) {
				if (valid) {
					_this4.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this4.addLoading = true;

						var para = (0, _assign2.default)({}, _this4.addForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.addUser)(para).then(function (res) {
							_this4.addLoading = false;

							_this4.$message({
								message: '提交成功',
								type: 'success'
							});
							_this4.$refs['addForm'].resetFields();
							_this4.addFormVisible = false;
							_this4.getUsers();
						});
					});
				}
			});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this5 = this;

			var ids = this.sels.map(function (item) {
				return item.id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then(function () {
				_this5.listLoading = true;

				var para = { ids: ids };
				(0, _api.batchRemoveUser)(para).then(function (res) {
					_this5.listLoading = false;

					_this5.$message({
						message: '删除成功',
						type: 'success'
					});
					_this5.getUsers();
				});
			}).catch(function () {});
		}
	},
	mounted: function mounted() {
		this.getUsers();
	}
};

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(44);

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			loading: false,
			users: []
		};
	},

	methods: {
		formatSex: function formatSex(row, column) {
			return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
		},

		getUser: function getUser() {
			var _this = this;

			var para = {
				name: this.filters.name
			};
			this.loading = true;

			(0, _api.getUserList)(para).then(function (res) {
				_this.users = res.data.users;
				_this.loading = false;
			});
		}
	},
	mounted: function mounted() {
		this.getUser();
	}
};

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(109);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(106);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getCount'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['increment', 'decrement']))
};

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      mainTable: [{
        lc: 1,
        itemType: "销售额",
        item: "（一）按适用税率计税销售额",
        titles: ["\u7B2C1\u680F\u201C\uFF08\u4E00\uFF09\u6309\u9002\u7528\u7A0E\u7387\u5F81\u7A0E\u9500\u552E\u989D\u201D\uFF1A\u586B\u5199\u7EB3\u7A0E\u4EBA\u672C\u671F\u6309\u4E00\u822C\u8BA1\u7A0E\u65B9\u6CD5\u8BA1\u7B97\u7F34\u7EB3\u589E\u503C\u7A0E\u7684\u9500\u552E\u989D \uFF0C\u5305\u542B\uFF1A", "", "\u5728\u8D22\u52A1\u4E0A\u4E0D\u4F5C\u9500\u552E\u4F46\u6309\u7A0E\u6CD5\u89C4\u5B9A\u5E94\u7F34\u7EB3\u589E\u503C\u7A0E\u7684\u89C6\u540C\u9500\u552E\u548C\u4EF7\u5916\u8D39\u7528\u7684\u9500\u552E\u989D\uFF1B\u5916\u8D38\u4F01\u4E1A\u4F5C\u4EF7\u9500\u552E\u8FDB\u6599\u52A0\u5DE5\u590D\u51FA\u53E3\u8D27\u7269\u7684\u9500\u552E\u989D\uFF1B\u7A0E\u52A1\u3001\u8D22\u653F\u3001\u5BA1\u8BA1\u90E8\u95E8\u68C0\u67E5\u540E\u6309\u4E00\u822C\u8BA1\u7A0E\u65B9\u6CD5\u8BA1\u7B97\u8C03\u6574\u7684\u9500\u552E\u989D \u3002", "", "\u201C\u8425\u6539\u589E\u201D\u7EB3\u7A0E\u4EBA\uFF0C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u548C\u65E0\u5F62\u8D44\u4EA7\u6709\u6263\u9664\u9879\u76EE\u7684\uFF0C\u5E94\u586B\u5199\u6263\u9664\u4E4B\u524D\u7684\u4E0D\u542B\u7A0E\u9500\u552E\u989D\u3002", "", "\u7B2C2\u30013\u680F\u7684\u201C\u5176\u4E2D\u201D\u4E0E\u7B2C1\u680F\u65E0\u5B8C\u5168\u5BF9\u6620\u5173\u7CFB\uFF0C\u201C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u548C\u65E0\u5F62\u8D44\u4EA7\u201D\u9500\u552E\u989D\u4E0D\u5305\u62EC\u5728\u5176\u4E2D\u3002"]
      }, {
        lc: 2,
        item: "其中：应税货物销售额",
        titles: ["\u586B\u5199\u7EB3\u7A0E\u4EBA\u672C\u671F\u6309\u9002\u7528\u7A0E\u7387\u8BA1\u7B97\u589E\u503C\u7A0E\u7684\u5E94\u7A0E\u8D27\u7269\u7684\u9500\u552E\u989D\u3002", "\u5305\u542B\u5728\u8D22\u52A1\u4E0A\u4E0D\u4F5C\u9500\u552E\u4F46\u6309\u7A0E\u6CD5\u89C4\u5B9A\u5E94\u7F34\u7EB3\u589E\u503C\u7A0E\u7684\u89C6\u540C\u9500\u552E\u8D27\u7269\u548C\u4EF7\u5916\u8D39\u7528\u9500\u552E\u989D\uFF0C\u4EE5\u53CA\u5916\u8D38\u4F01\u4E1A\u4F5C\u4EF7\u9500\u552E\u8FDB\u6599\u52A0\u5DE5\u590D\u51FA\u53E3\u8D27\u7269\u7684\u9500\u552E\u989D\u3002"]
      }, {
        lc: 3,
        item: "           应税劳务销售额"
      }, {
        lc: 4,
        item: "           纳税检查调整的销售额",
        titles: ["\u586B\u5199\u7EB3\u7A0E\u4EBA\u56E0\u7A0E\u52A1\u3001\u8D22\u653F\u3001\u5BA1\u8BA1\u90E8\u95E8\u68C0\u67E5\uFF0C\u5E76\u6309\u4E00\u822C\u8BA1\u7A0E\u65B9\u6CD5\u5728\u672C\u671F\u8BA1\u7B97\u8C03\u6574\u7684\u9500\u552E\u989D\u3002", "", "\u4EAB\u53D7\u589E\u503C\u7A0E\u5373\u5F81\u5373\u9000\u653F\u7B56\u7684\u8D27\u7269\u3001\u52B3\u52A1\u548C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u3001\u65E0\u5F62\u8D44\u4EA7\uFF0C\u7ECF\u7EB3\u7A0E\u68C0\u67E5\u5C5E\u4E8E\u5077\u7A0E\u7684\uFF0C\u4E0D\u586B\u5165\u201C\u5373\u5F81\u5373\u9000\u9879\u76EE\u201D\u5217\uFF0C\u800C\u5E94\u586B\u5165\u201C\u4E00\u822C\u9879\u76EE\u201D\u5217\u3002", "", "\u201C\u8425\u6539\u589E\u201D\u7EB3\u7A0E\u4EBA\uFF0C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u548C\u65E0\u5F62\u8D44\u4EA7\u6709\u6263\u9664\u9879\u76EE\u7684\uFF0C\u672C\u680F\u5E94\u586B\u5199\u6263\u9664\u4E4B\u524D\u7684\u4E0D\u542B\u7A0E\u9500\u552E\u989D\u3002"]
      }, {
        lc: 5,
        item: "（二）按简易办法计税销售额",
        titles: ["\u586B\u5199\u7EB3\u7A0E\u4EBA\u672C\u671F\u6309\u7B80\u6613\u8BA1\u7A0E\u65B9\u6CD5\u8BA1\u7B97\u589E\u503C\u7A0E\u7684\u9500\u552E\u989D\u3002\u5305\u542B\u7EB3\u7A0E\u68C0\u67E5\u8C03\u6574\u6309\u7B80\u6613\u8BA1\u7A0E\u65B9\u6CD5\u8BA1\u7B97\u589E\u503C\u7A0E\u9500\u552E\u989D\u3002", "", "\u201C\u8425\u6539\u589E\u201D\u7EB3\u7A0E\u4EBA\uFF0C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u548C\u65E0\u5F62\u8D44\u4EA7\u6709\u6263\u9664\u9879\u76EE\u7684\uFF0C\u672C\u680F\u5E94\u586B\u5199\u6263\u9664\u4E4B\u524D\u7684\u4E0D\u542B\u7A0E\u9500\u552E\u989D\uFF1B", "", "\u201C\u8425\u6539\u589E\u201D\u7EB3\u7A0E\u4EBA\uFF0C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u548C\u65E0\u5F62\u8D44\u4EA7\u6309\u89C4\u5B9A\u6C47\u603B\u8BA1\u7B97\u7F34\u7EB3\u589E\u503C\u7A0E\u7684\u5206\u652F\u673A\u6784\uFF0C\u5176\u5F53\u671F\u6309\u9884\u5F81\u7387\u8BA1\u7B97\u7F34\u7EB3\u589E\u503C\u7A0E\u7684\u9500\u552E\u989D\u4E5F\u586B\u5165\u672C\u680F\u3002"]
      }, {
        lc: 6,
        item: "其中：纳税检查调整的销售额",
        titles: ["\u7EB3\u7A0E\u68C0\u67E5\u8C03\u6574\u7684\u9500\u552E\u989D\u201D\uFF1A\u586B\u5199\u7EB3\u7A0E\u4EBA\u56E0\u7A0E\u52A1\u3001\u8D22\u653F\u3001\u5BA1\u8BA1\u90E8\u95E8\u68C0\u67E5\uFF0C\u5E76\u6309\u7B80\u6613\u8BA1\u7A0E\u65B9\u6CD5\u5728\u672C\u671F\u8BA1\u7B97\u8C03\u6574\u7684\u9500\u552E\u989D\u3002", "\u4EAB\u53D7\u589E\u503C\u7A0E\u5373\u5F81\u5373\u9000\u653F\u7B56\u7684\u8D27\u7269\u3001\u52B3\u52A1\u548C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u3001\u65E0\u5F62\u8D44\u4EA7\uFF0C\u7ECF\u7EB3\u7A0E\u68C0\u67E5\u53D1\u73B0\u5077\u7A0E\u7684\uFF0C\u4E0D\u586B\u5165\u201C\u5373\u5F81\u5373\u9000\u9879\u76EE\u201D\u5217\uFF0C\u5E94\u586B\u5165\u201C\u4E00\u822C\u9879\u76EE\u201D\u5217\u3002", "", "\u201C\u8425\u6539\u589E\u201D\u7EB3\u7A0E\u4EBA\uFF0C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u548C\u65E0\u5F62\u8D44\u4EA7\u6709\u6263\u9664\u9879\u76EE\u7684\uFF0C\u5E94\u586B\u5199\u6263\u9664\u4E4B\u524D\u7684\u4E0D\u542B\u7A0E\u9500\u552E\u989D\u3002"]
      }, {
        lc: 7,
        item: "（三）免、抵、退办法出口销售额",
        titles: ["\u201C\u514D\u3001\u62B5\u3001\u9000\u529E\u6CD5\u51FA\u53E3\u9500\u552E\u989D\u201D\uFF1A\u586B\u5199\u7EB3\u7A0E\u4EBA\u672C\u671F\u9002\u7528\u514D\u3001\u62B5\u3001\u9000\u7A0E\u529E\u6CD5\u7684\u51FA\u53E3\u8D27\u7269\u3001\u52B3\u52A1\u548C\u670D\u52A1\u3001\u65E0\u5F62\u8D44\u4EA7\u7684\u9500\u552E\u989D\u3002"]
      }, {
        lc: 8,
        item: "（四）免税销售额",
        titles: ["\u201C\u514D\u7A0E\u9500\u552E\u989D\u201D\uFF1A\u586B\u5199\u7EB3\u7A0E\u4EBA\u672C\u671F\u6309\u7167\u7A0E\u6CD5\u89C4\u5B9A\u514D\u5F81\u589E\u503C\u7A0E\u7684\u9500\u552E\u989D\u548C\u9002\u7528\u96F6\u7A0E\u7387\u7684\u9500\u552E\u989D\uFF0C\u4F46\u96F6\u7A0E\u7387\u7684\u9500\u552E\u989D\u4E2D\u4E0D\u5305\u62EC\u9002\u7528\u514D\u3001\u62B5\u3001\u9000\u7A0E\u529E\u6CD5\u7684\u9500\u552E\u989D\u3002", "", "\u7B2C9\u300110\u680F\u7684\u201C\u5176\u4E2D\u201D\u4E0E\u7B2C8\u680F\u65E0\u5B8C\u5168\u5BF9\u6620\u5173\u7CFB\uFF0C\u201C\u514D\u7A0E\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u548C\u65E0\u5F62\u8D44\u4EA7\u9500\u552E\u989D\u201D\u4E0D\u5305\u62EC\u5728\u5176\u4E2D\u3002"]
      }, {
        lc: 9,
        item: "其中：免税货物销售额"
      }, {
        lc: 10,
        item: "           免税劳务销售额"
      }, {
        lc: 11,
        itemType: "税款计算",
        item: "销项税额",
        titles: ["\u586B\u5199\u7EB3\u7A0E\u4EBA\u672C\u671F\u6309\u4E00\u822C\u8BA1\u7A0E\u65B9\u6CD5\u8BA1\u7A0E\u7684\u8D27\u7269\u3001\u52B3\u52A1\u548C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u3001\u65E0\u5F62\u8D44\u4EA7\u7684\u9500\u9879\u7A0E\u3002", "", "\u201C\u8425\u6539\u589E\u201D\u7EB3\u7A0E\u4EBA\uFF0C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u3001\u65E0\u5F62\u8D44\u4EA7\u6709\u6263\u9664\u9879\u76EE\u7684\uFF0C\u672C\u680F\u5E94\u586B\u5199\u6263\u9664\u4E4B\u540E\u7684\u9500\u9879\u7A0E\u989D\u3002"]
      }, {
        lc: 12,
        item: "进项税额",
        titles: ["\u201C\u4E00\u822C\u9879\u76EE\u201D\u5217\u201C\u672C\u6708\u6570\u201D+\u201C\u5373\u5F81\u5373\u9000\u9879\u76EE\u201D\u5217\u201C\u672C\u6708\u6570\u201D\uFF1D\u300A\u9644\u8868\uFF08\u4E8C\uFF09\u300B\u7B2C12\u680F\u201C\u7A0E\u989D\u201D\u3002"]
      }, {
        lc: 13,
        item: "上期留抵税额",
        titles: ["\u65E0\u987B\u201C\u6302\u8D26\u201D\u7559\u62B5\u7684\u7EB3\u7A0E\u4EBA\uFF0C\u6309\u4EE5\u4E0B\u8981\u6C42\u586B\u5199\u672C\u680F\u201C\u672C\u6708\u6570\u201D\u548C\u201C\u672C\u5E74\u7D2F\u8BA1\u201D\uFF1A\uFF08\u9700\u201C\u6302\u8D26\u201D\u60C5\u51B5\u5C06\u5728\u540E\u9762\u4E13\u9898\u8BF4\u660E\uFF09", "\u672C\u680F\u201C\u4E00\u822C\u9879\u76EE\u201D\u5217\u201C\u672C\u6708\u6570\u201D\uFF1A\u6309\u4E0A\u671F\u7533\u62A5\u8868\u7B2C20\u680F\u201C\u671F\u672B\u7559\u62B5\u7A0E\u989D\u201D\u201C\u4E00\u822C\u9879\u76EE\u201D\u5217\u201C\u672C\u6708\u6570\u201D\u586B\u5199\u3002", "\u672C\u680F\u201C\u5373\u5F81\u5373\u9000\u9879\u76EE\u201D\u5217\u201C\u672C\u6708\u6570\u201D\uFF1A\u6309\u4E0A\u671F\u7533\u62A5\u8868\u7B2C20\u680F\u201C\u671F\u672B\u7559\u62B5\u7A0E\u989D\u201D\u201C\u5373\u5F81\u5373\u9000\u9879\u76EE\u201D\u5217\u201C\u672C\u6708\u6570\u201D\u586B\u5199\u3002 ", "\u672C\u680F\u201C\u4E00\u822C\u9879\u76EE\u201D\u5217\u201C\u672C\u5E74\u7D2F\u8BA1\u201D\uFF1A\u586B\u5199\u201C0\u201D"]
      }, {
        lc: 14,
        item: "进项税额转出"
      }, {
        lc: 15,
        item: "免、抵、退应退税额",
        titles: ["\u53CD\u6620\u7A0E\u52A1\u673A\u5173\u9000\u7A0E\u90E8\u95E8\u6309\u7167\u51FA\u53E3\u8D27\u7269\u3001\u52B3\u52A1\u548C\u670D\u52A1\u3001\u65E0\u5F62\u8D44\u4EA7\u514D\u3001\u62B5\u3001\u9000\u529E\u6CD5\u5BA1\u6279\u7684\u589E\u503C\u7A0E\u5E94\u9000\u7A0E\u989D\u3002"]
      }, {
        lc: 16,
        item: "按适用税率计算的纳税检查应补缴税额"
      }, {
        lc: "17=12+13-14-15+16",
        item: "应抵扣税额合计"
      }, {
        lc: "18\uFF08\u598217<11\uFF0C\u5219\u4E3A17\uFF0C\u5426\u5219\u4E3A11\uFF09",
        item: "实际抵扣税额",
        titles: ["\u201C\u5B9E\u9645\u62B5\u6263\u7A0E\u989D\u201D\uFF0C\u65E0\u987B\u6302\u8D26\u7559\u62B5\u7684\u7EB3\u7A0E\u4EBA\uFF0C\u6309\u4EE5\u4E0B\u8981\u6C42\u586B\u5199\u672C\u680F\u201C\u672C\u6708\u6570\u201D\u548C\u201C\u672C\u5E74\u7D2F\u8BA1\u201D\uFF1A", "", "\u672C\u680F\u201C\u4E00\u822C\u9879\u76EE\u201D\u5217\u201C\u672C\u6708\u6570\u201D\uFF1A\u6309\u8868\u4E2D\u6240\u5217\u516C\u5F0F\u8BA1\u7B97\u586B\u5199\u3002 \uFF08\u201C\u5E94\u62B5\u6263\u7A0E\u989D\u201D\u4E0E\u201C\u9500\u9879\u7A0E\u989D\u201D\u5BF9\u6BD4\uFF0C\u8C01\u5C0F\u6263\u8C01\uFF09", "\u672C\u680F\u201C\u5373\u5F81\u5373\u9000\u9879\u76EE\u201D\u5217\u201C\u672C\u6708\u6570\u201D\uFF1A\u6309\u8868\u4E2D\u6240\u5217\u516C\u5F0F\u8BA1\u7B97\u586B\u5199\u3002", "\u672C\u680F\u201C\u4E00\u822C\u9879\u76EE\u201D\u5217\u201C\u672C\u5E74\u7D2F\u8BA1\u201D\uFF1A\u586B\u5199\u201C0\u201D "]
      }, {
        lc: "19=11-18",
        item: "应纳税额"
      }, {
        lc: "20=17-18",
        item: "期末留抵税额"
      }, {
        lc: 21,
        item: "简易计税办法计算的应纳税额",
        titles: ["\u53CD\u6620\u7EB3\u7A0E\u4EBA\u672C\u671F\u6309\u7B80\u6613\u8BA1\u7A0E\u65B9\u6CD5\u8BA1\u7B97\u5E76\u5E94\u7F34\u7EB3\u7684\u589E\u503C\u7A0E\u989D\uFF0C\u4F46\u4E0D\u5305\u62EC\u7EB3\u7A0E\u68C0\u67E5\u5E94\u8865\u7F34\u7A0E\u989D\u3002", "", "\u201C\u8425\u6539\u589E\u201D\u7EB3\u7A0E\u4EBA\uFF0C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u548C\u65E0\u5F62\u8D44\u4EA7\u6309\u89C4\u5B9A\u6C47\u603B\u8BA1\u7B97\u7F34\u7EB3\u589E\u503C\u7A0E\u7684\u5206\u652F\u673A\u6784\uFF0C\u5E94\u5C06\u9884\u5F81\u589E\u503C\u7A0E\u989D\u586B\u5165\u672C\u680F\u3002\u9884\u5F81\u589E\u503C\u7A0E\u989D=\u5E94\u9884\u5F81\u589E\u503C\u7A0E\u7684\u9500\u552E\u989D\xD7\u9884\u5F81\u7387\u3002"]
      }, {
        lc: 22,
        item: "按简易计税办法计算的纳税检查应补缴税额"
      }, {
        lc: 23,
        item: "应纳税额减征额",
        titles: ["\u586B\u5199\u7EB3\u7A0E\u4EBA\u672C\u671F\u6309\u7167\u7A0E\u6CD5\u89C4\u5B9A\u51CF\u5F81\u7684\u589E\u503C\u7A0E\u5E94\u7EB3\u7A0E\u989D\u3002\u5305\u542B\u6309\u7167\u89C4\u5B9A\u53EF\u5728\u589E\u503C\u7A0E\u5E94\u7EB3\u7A0E\u989D\u4E2D\u5168\u989D\u62B5\u51CF\u7684\u589E\u503C\u7A0E\u7A0E\u63A7\u7CFB\u7EDF\u4E13\u7528\u8BBE\u5907\u8D39\u7528\u4EE5\u53CA\u6280\u672F\u7EF4\u62A4\u8D39\u3002", "", "\u5F53\u672C\u671F\u51CF\u5F81\u989D\u5C0F\u4E8E\u6216\u7B49\u4E8E\u7B2C19\u680F\u201C\u5E94\u7EB3\u7A0E\u989D\u201D\u4E0E\u7B2C21\u680F\u201C\u7B80\u6613\u8BA1\u7A0E\u529E\u6CD5\u8BA1\u7B97\u7684\u5E94\u7EB3\u7A0E\u989D\u201D\u4E4B\u548C\u65F6\uFF0C\u6309\u672C\u671F\u51CF\u5F81\u989D\u5B9E\u9645\u586B\u5199\uFF1B", "\u5F53\u672C\u671F\u51CF\u5F81\u989D\u5927\u4E8E\u7B2C19\u680F\u201C\u5E94\u7EB3\u7A0E\u989D\u201D\u4E0E\u7B2C21\u680F\u201C\u7B80\u6613\u8BA1\u7A0E\u529E\u6CD5\u8BA1\u7B97\u7684\u5E94\u7EB3\u7A0E\u989D\u201D\u4E4B\u548C\u65F6\uFF0C\u6309\u672C\u671F\u7B2C19\u680F\u4E0E\u7B2C21\u680F\u4E4B\u548C\u586B\u5199\u3002\u672C\u671F\u51CF\u5F81\u989D\u4E0D\u8DB3\u62B5\u51CF\u90E8\u5206\u7ED3\u8F6C\u4E0B\u671F\u7EE7\u7EED\u62B5\u51CF\u3002"]
      }, {
        lc: "24=19+21-23",
        item: "应纳税额合计"
      }, {
        lc: 25,
        itemType: "税款缴纳",
        item: "期初未缴税额（多缴为负数）",
        titles: ["\u201C\u671F\u521D\u672A\u7F34\u7A0E\u989D\uFF08\u591A\u7F34\u4E3A\u8D1F\u6570\uFF09\u201D\uFF1A\u201C\u672C\u6708\u6570\u201D\u6309\u4E0A\u4E00\u7A0E\u6B3E\u6240\u5C5E\u671F\u7533\u62A5\u8868\u7B2C32\u680F\u201C\u671F\u672B\u672A\u7F34\u7A0E\u989D\uFF08\u591A\u7F34\u4E3A\u8D1F\u6570\uFF09\u201D\u201C\u672C\u6708\u6570\u201D\u586B\u5199\u3002", " \u201C\u672C\u5E74\u7D2F\u8BA1\u201D\u6309\u4E0A\u5E74\u5EA6\u6700\u540E\u4E00\u4E2A\u7A0E\u6B3E\u6240\u5C5E\u671F\u7533\u62A5\u8868\u7B2C32\u680F\u201C\u671F\u672B\u672A\u7F34\u7A0E\u989D\uFF08\u591A\u7F34\u4E3A\u8D1F\u6570\uFF09\u201D\u201C\u672C\u5E74\u7D2F\u8BA1\u201D\u586B\u5199\u3002"]
      }, { lc: 26, item: "实收出口开具专用缴款书退税额" }, {
        lc: "27=28+29+30+31",
        item: "本期已缴税额",
        titles: ["\u53CD\u6620\u7EB3\u7A0E\u4EBA\u672C\u671F\u5B9E\u9645\u7F34\u7EB3\u7684\u589E\u503C\u7A0E\u989D\uFF0C\u4F46\u4E0D\u5305\u62EC\u672C\u671F\u5165\u5E93\u7684\u67E5\u8865\u7A0E\u6B3E\u3002\u6309\u8868\u4E2D\u6240\u5217\u516C\u5F0F\u8BA1\u7B97\u586B\u5199\u3002"]
      }, {
        lc: 28,
        item: "①分次预缴税额",
        titles: ["\u586B\u5199\u7EB3\u7A0E\u4EBA\u672C\u671F\u5DF2\u7F34\u7EB3\u7684\u51C6\u4E88\u5728\u672C\u671F\u5E94\u7EB3\u7A0E\u989D\u4E2D\u62B5\u51CF\u7684\u7A0E\u989D\u3002", "", "\u201C\u8425\u6539\u589E\u201D\u7EB3\u7A0E\u4EBA\uFF0C\u670D\u52A1\u3001\u4E0D\u52A8\u4EA7\u548C\u65E0\u5F62\u8D44\u4EA7\u6309\u89C4\u5B9A\u6C47\u603B\u8BA1\u7B97\u7F34\u7EB3\u589E\u503C\u7A0E\u7684\u603B\u673A\u6784\uFF0C\u5176\u53EF\u4EE5\u4ECE\u672C\u671F\u589E\u503C\u7A0E\u5E94\u7EB3\u7A0E\u989D\u4E2D\u62B5\u51CF\u7684\u5206\u652F\u673A\u6784\u5DF2\u7F34\u7EB3\u7684\u7A0E\u6B3E;", "\u9500\u552E\u5EFA\u7B51\u670D\u52A1\u5E76\u6309\u89C4\u5B9A\u9884\u7F34\u589E\u503C\u7A0E\u7684\u7EB3\u7A0E\u4EBA\uFF0C\u5176\u53EF\u4EE5\u4ECE\u672C\u671F\u589E\u503C\u7A0E\u5E94\u7EB3\u7A0E\u989D\u4E2D\u62B5\u51CF\u7684\u5DF2\u7F34\u7EB3\u7684\u7A0E\u6B3E;", "\u9500\u552E\u3001\u51FA\u79DF\u4E0D\u52A8\u4EA7\u5E76\u6309\u89C4\u5B9A\u9884\u7F34\u589E\u503C\u7A0E\u7684\u7EB3\u7A0E\u4EBA\uFF0C\u5176\u53EF\u4EE5\u4ECE\u672C\u671F\u589E\u503C\u7A0E\u5E94\u7EB3\u7A0E\u989D\u4E2D\u62B5\u51CF\u7684\u5DF2\u7F34\u7EB3\u7684\u7A0E\u6B3E\uFF0C\u6309\u5F53\u671F\u5B9E\u9645\u53EF\u62B5\u51CF\u6570\u586B\u5165\u672C\u680F\uFF0C\u4E0D\u8DB3\u62B5\u51CF\u90E8\u5206\u7ED3\u8F6C\u4E0B\u671F\u7EE7\u7EED\u62B5\u51CF\u3002"]
      }, { lc: 29, item: "②出口开具专用缴款书预缴税额" }, { lc: 30, item: "③本期缴纳上期应纳税额" }, {
        lc: 31,
        item: "④本期缴纳欠缴税额",
        titles: ["\u53CD\u6620\u7EB3\u7A0E\u4EBA\u672C\u671F\u5B9E\u9645\u7F34\u7EB3\u548C\u7559\u62B5\u7A0E\u989D\u62B5\u51CF\u7684\u589E\u503C\u7A0E\u6B20\u7A0E\u989D\uFF0C\u4F46\u4E0D\u5305\u62EC\u7F34\u7EB3\u5165\u5E93\u7684\u67E5\u8865\u589E\u503C\u7A0E\u989D\u3002"]
      }, {
        lc: "32=24+25+26-27",
        item: "期末未缴税额（多缴为负数）",
        titles: ["\u201C\u672C\u6708\u6570\u201D\u53CD\u6620\u7EB3\u7A0E\u4EBA\u672C\u671F\u671F\u672B\u5E94\u7F34\u672A\u7F34\u7684\u589E\u503C\u7A0E\u989D\uFF0C\u4F46\u4E0D\u5305\u62EC\u7EB3\u7A0E\u68C0\u67E5\u5E94\u7F34\u672A\u7F34\u7684\u7A0E\u989D\u3002\u6309\u8868\u4E2D\u6240\u5217\u516C\u5F0F\u8BA1\u7B97\u586B\u5199\u3002\u201C\u672C\u5E74\u7D2F\u8BA1\u201D\u4E0E\u201C\u672C\u6708\u6570\u201D\u76F8\u540C\u3002"]
      }, {
        lc: "33=25+26-27",
        item: "其中：欠缴税额（≥0）",
        titles: ["\u53CD\u6620\u7EB3\u7A0E\u4EBA\u6309\u7167\u7A0E\u6CD5\u89C4\u5B9A\u5DF2\u5F62\u6210\u6B20\u7A0E\u7684\u589E\u503C\u7A0E\u989D\u3002\u6309\u8868\u4E2D\u6240\u5217\u516C\u5F0F\u8BA1\u7B97\u586B\u5199\u3002"]
      }, {
        lc: "34\uFF1D24-28-29",
        item: "本期应补(退)税额",
        titles: ["\u53CD\u6620\u7EB3\u7A0E\u4EBA\u672C\u671F\u5E94\u7EB3\u7A0E\u989D\u4E2D\u5E94\u8865\u7F34\u6216\u5E94\u9000\u56DE\u7684\u6570\u989D\u3002\u6309\u8868\u4E2D\u6240\u5217\u516C\u5F0F\u8BA1\u7B97\u586B\u5199\u3002"]
      }, { lc: 35, item: "即征即退实际退税额" }, {
        lc: 36,
        item: "期初未缴查补税额",
        titles: ["\u201C\u672C\u6708\u6570\u201D\u6309\u4E0A\u4E00\u7A0E\u6B3E\u6240\u5C5E\u671F\u7533\u62A5\u8868\u7B2C38\u680F\u201C\u671F\u672B\u672A\u7F34\u67E5\u8865\u7A0E\u989D\u201D\u201C\u672C\u6708\u6570\u201D\u586B\u5199\u3002\u201C\u672C\u5E74\u7D2F\u8BA1\u201D\u6309\u4E0A\u5E74\u5EA6\u6700\u540E\u4E00\u4E2A\u7A0E\u6B3E\u6240\u5C5E\u671F\u7533\u62A5\u8868\u7B2C38\u680F\u201C\u671F\u672B\u672A\u7F34\u67E5\u8865\u7A0E\u989D\u201D\u201C\u672C\u5E74\u7D2F\u8BA1\u201D\u586B\u5199\u3002"]
      }, {
        lc: 37,
        item: "本期入库查补税额",
        titles: ["\u53CD\u6620\u7EB3\u7A0E\u4EBA\u672C\u671F\u56E0\u7A0E\u52A1\u3001\u8D22\u653F\u3001\u5BA1\u8BA1\u90E8\u95E8\u68C0\u67E5\u800C\u5B9E\u9645\u5165\u5E93\u7684\u589E\u503C\u7A0E\u989D\uFF0C\u5305\u62EC\u6309\u4E00\u822C\u8BA1\u7A0E\u65B9\u6CD5\u8BA1\u7B97\u5E76\u5B9E\u9645\u7F34\u7EB3\u7684\u67E5\u8865\u589E\u503C\u7A0E\u989D\u548C\u6309\u7B80\u6613\u8BA1\u7A0E\u65B9\u6CD5\u8BA1\u7B97\u5E76\u5B9E\u9645\u7F34\u7EB3\u7684\u67E5\u8865\u589E\u503C\u7A0E\u989D\u3002 "]
      }, {
        lc: "38=16+22+36-37",
        item: "期末未缴查补税额",
        titles: ["\u201C\u672C\u6708\u6570\u201D\u53CD\u6620\u7EB3\u7A0E\u4EBA\u63A5\u53D7\u7EB3\u7A0E\u68C0\u67E5\u540E\u5E94\u5728\u672C\u671F\u671F\u672B\u7F34\u7EB3\u800C\u672A\u7F34\u7EB3\u7684\u67E5\u8865\u589E\u503C\u7A0E\u989D\u3002\u6309\u8868\u4E2D\u6240\u5217\u516C\u5F0F\u8BA1\u7B97\u586B\u5199\uFF0C\u201C\u672C\u5E74\u7D2F\u8BA1\u201D\u4E0E\u201C\u672C\u6708\u6570\u201D\u76F8\u540C\u3002"]
      }, {
        itemType: "    \n    \u6388\n    \u6743\n    \u58F0\n    \u660E        ",
        item: "      如果你已委托代理人申报，请填写下列资料：",
        a2: "\n                               \u7533\n                               \u62A5\n                               \u4EBA\n                               \u58F0\n                               \u660E        ",
        b1: ""
      }, {
        item: "      为代理一切税务事宜，现授权                                                                ",
        b1: "   本纳税申报表是根据国家税收法律法规及相关规定填报的，我确定它是真实的、可靠的、完整的。"
      }, {
        item: "（地址）                                             为本纳税人的代理申报人，任何与本",
        b1: ""
      }, { item: "申报表有关的往来文件，都可寄予此人。", b1: "" }, { item: "", b1: "" }, {
        item: "                                                                                授权人签字：",
        b1: "                                                                           声明人签字："
      }]
    };
  },

  methods: {
    inputChange: function inputChange(row, value) {
      var _this = this;

      var lc = parseInt(row.lc);
      var map = [{
        lc: "17",
        lcs: [12, 13, 14, 15, 16],
        handel: function handel(lc, v) {
          if (lc == 14 || lc == 15) {
            return -v;
          }
          return v;
        }
      }, {
        lc: "18",
        lcs: [17, 11],
        handel: function handel(lc, v, total) {
          debugger;
          if (lc == 11) return v;
          if (lc == 17 && v < total) {
            return v - total;
          }
          return 0;
        }
      }, {
        lc: "19",
        lcs: [11, 18],
        handel: function handel(lc, v) {
          if (lc == 18) return -v;
          return v;
        }
      }, {
        lc: "20",
        lcs: [17, 18],
        handel: function handel(lc, v) {
          if (lc == 18) return -v;
          return v;
        }
      }, {
        lc: "24",
        lcs: [19, 21, 23],
        handel: function handel(lc, v) {
          if (lc == 23) return -v;
          return v;
        }
      }, {
        lc: "27",
        lcs: [28, 29, 30, 31],
        handel: function handel(lc, v) {
          return v;
        }
      }, {
        lc: "32",
        lcs: [24, 25, 26, 27],
        handel: function handel(lc, v) {
          if (lc == 27) return -v;
          return v;
        }
      }, {
        lc: "33",
        lcs: [25, 26, 27],
        handel: function handel(lc, v) {
          if (lc == 27) return -v;
          return v;
        }
      }, {
        lc: "34",
        lcs: [24, 28, 29],
        handel: function handel(lc, v) {
          if (lc == 24) return v;
          return -v;
        }
      }, {
        lc: "38",
        lcs: [16, 22, 36, 37],
        handel: function handel(lc, v) {
          if (lc == 37) return -v;
          return v;
        }
      }];
      map.forEach(function (t) {
        var lc = t.lc,
            lcs = t.lcs,
            handel = t.handel;


        var toUpdate = _this.mainTable.filter(function (m) {
          return parseInt(m.lc) == lc;
        })[0];
        var toCompute = _this.mainTable.filter(function (m) {
          return lcs.includes(parseInt(m.lc));
        });
        var result = { a1: 0, a2: 0, b1: 0, b2: 0 };

        toCompute.forEach(function (m) {
          for (var ab in result) {
            if (result.hasOwnProperty(ab) && m.hasOwnProperty(ab)) {
              var v = parseInt(m[ab]);
              if (!isNaN(v)) {
                result[ab] += handel(parseInt(m.lc), v, result[ab]);
              }
            }
          }
        });

        toUpdate.a1 = result.a1;
        toUpdate.a2 = result.a2;
        toUpdate.b1 = result.b1;
        toUpdate.b2 = result.b2;
      });
    },
    isDisable: function isDisable(row) {
      var lc = parseInt(row.lc);
      var lcs = [17, 18, 19, 20, 24, 27, 32, 33, 34, 38];
      if (lcs.includes(lc)) {
        return true;
      }
      return false;
    },
    rowClass: function rowClass(row, rowIndex) {
      if (row.rowIndex >= 38) {
        return "non-edit can-space";
      }
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (columnIndex == 0) {
        if (rowIndex == 0) {
          return {
            rowspan: 10,
            colspan: 1
          };
        } else if (rowIndex == 10) {
          return {
            rowspan: 14,
            colspan: 1
          };
        } else if (rowIndex == 24) {
          return {
            rowspan: 14,
            colspan: 1
          };
        } else if (rowIndex == 38) {
          return {
            rowspan: 6,
            colspan: 2
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }

      if (rowIndex == 38 && columnIndex == 4) {
        return {
          rowspan: 6,
          colspan: 1
        };
      }

      switch (rowIndex) {
        case 38:
        case 39:
        case 40:
        case 41:
        case 42:
        case 43:
          if (columnIndex == 1 || columnIndex == 5) {
            return {
              rowspan: 1,
              colspan: 2
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
      }
    }
  }
};

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      A_1_1: 0,
      A_1_2: 0,
      A_1_3: 0,
      A_1_4: 0,
      A_1_5: 0,
      A_1_6: 0,
      A_1_7: 0,
      A_1_8: 0,
      A_1_12: 0,
      A_2_1: 0,
      A_2_2: 0,
      A_2_3: 0,
      A_2_4: 0,
      A_2_5: 0,
      A_2_6: 0,
      A_2_7: 0,
      A_2_8: 0,
      A_2_12: 0,
      A_3_1: 0,
      A_3_2: 0,
      A_3_3: 0,
      A_3_4: 0,
      A_3_5: 0,
      A_3_6: 0,
      A_3_7: 0,
      A_3_8: 0,
      A_3_12: 0,
      A_4_1: 0,
      A_4_2: 0,
      A_4_3: 0,
      A_4_4: 0,
      A_4_5: 0,
      A_4_6: 0,
      A_4_7: 0,
      A_4_8: 0,
      A_4_12: 0,
      A_5_1: 0,
      A_5_2: 0,
      A_5_3: 0,
      A_5_4: 0,
      A_5_5: 0,
      A_5_6: 0,
      A_5_7: 0,
      A_5_8: 0,
      A_5_12: 0,
      A_6_1: 0,
      A_6_2: 0,
      A_6_3: 0,
      A_6_4: 0,
      A_6_5: 0,
      A_6_6: 0,
      A_6_7: 0,
      A_6_8: 0,
      A_6_12: 0,
      A_7_1: 0,
      A_7_2: 0,
      A_7_3: 0,
      A_7_4: 0,
      A_7_5: 0,
      A_7_6: 0,
      A_7_7: 0,
      A_7_8: 0,
      A_7_12: 0,
      A_8_1: 0,
      A_8_2: 0,
      A_8_3: 0,
      A_8_4: 0,
      A_8_5: 0,
      A_8_6: 0,
      A_8_7: 0,
      A_8_8: 0,
      A_8_12: 0,
      A_9a_1: 0,
      A_9a_2: 0,
      A_9a_3: 0,
      A_9a_4: 0,
      A_9a_5: 0,
      A_9a_6: 0,
      A_9a_7: 0,
      A_9a_8: 0,
      A_9a_12: 0,
      A_9b_1: 0,
      A_9b_2: 0,
      A_9b_3: 0,
      A_9b_4: 0,
      A_9b_5: 0,
      A_9b_6: 0,
      A_9b_7: 0,
      A_9b_8: 0,
      A_9b_12: 0,
      A_10_1: 0,
      A_10_2: 0,
      A_10_3: 0,
      A_10_4: 0,
      A_10_5: 0,
      A_10_6: 0,
      A_10_7: 0,
      A_10_8: 0,
      A_10_12: 0,
      A_11_1: 0,
      A_11_2: 0,
      A_11_3: 0,
      A_11_4: 0,
      A_11_5: 0,
      A_11_6: 0,
      A_11_7: 0,
      A_11_8: 0,
      A_11_12: 0,
      A_12_1: 0,
      A_12_2: 0,
      A_12_3: 0,
      A_12_4: 0,
      A_12_5: 0,
      A_12_6: 0,
      A_12_7: 0,
      A_12_8: 0,
      A_12_12: 0,
      A_13a_1: 0,
      A_13a_2: 0,
      A_13a_3: 0,
      A_13a_4: 0,
      A_13a_5: 0,
      A_13a_6: 0,
      A_13a_7: 0,
      A_13a_8: 0,
      A_13a_12: 0,
      A_13b_1: 0,
      A_13b_2: 0,
      A_13b_3: 0,
      A_13b_4: 0,
      A_13b_5: 0,
      A_13b_6: 0,
      A_13b_7: 0,
      A_13b_8: 0,
      A_13b_12: 0,
      A_13c_1: 0,
      A_13c_2: 0,
      A_13c_3: 0,
      A_13c_4: 0,
      A_13c_5: 0,
      A_13c_6: 0,
      A_13c_7: 0,
      A_13c_8: 0,
      A_13c_12: 0,
      A_14_1: 0,
      A_14_2: 0,
      A_14_3: 0,
      A_14_4: 0,
      A_14_5: 0,
      A_14_6: 0,
      A_14_7: 0,
      A_14_8: 0,
      A_14_12: 0,
      A_15_1: 0,
      A_15_2: 0,
      A_15_3: 0,
      A_15_4: 0,
      A_15_5: 0,
      A_15_6: 0,
      A_15_7: 0,
      A_15_8: 0,
      A_15_12: 0,
      A_16_1: 0,
      A_16_2: 0,
      A_16_3: 0,
      A_16_4: 0,
      A_16_5: 0,
      A_16_6: 0,
      A_16_7: 0,
      A_16_8: 0,
      A_16_12: 0,
      A_17_1: 0,
      A_17_2: 0,
      A_17_3: 0,
      A_17_4: 0,
      A_17_5: 0,
      A_17_6: 0,
      A_17_7: 0,
      A_17_8: 0,
      A_17_12: 0,
      A_18_1: 0,
      A_18_2: 0,
      A_18_3: 0,
      A_18_4: 0,
      A_18_5: 0,
      A_18_6: 0,
      A_18_7: 0,
      A_18_8: 0,
      A_18_12: 0,
      A_19_1: 0,
      A_19_2: 0,
      A_19_3: 0,
      A_19_4: 0,
      A_19_5: 0,
      A_19_6: 0,
      A_19_7: 0,
      A_19_8: 0,
      A_19_12: 0,
      sl: 0.1
    };
  },

  computed: {
    A_1_9: function A_1_9() {
      return +this.A_1_1 + +this.A_1_3 + +this.A_1_5 + +this.A_1_7;
    },
    A_2_9: function A_2_9() {
      return +this.A_2_1 + +this.A_2_3 + +this.A_2_5 + +this.A_2_7;
    },
    A_3_9: function A_3_9() {
      return +this.A_3_1 + +this.A_3_3 + +this.A_3_5 + +this.A_3_7;
    },
    A_4_9: function A_4_9() {
      return +this.A_4_1 + +this.A_4_3 + +this.A_4_5 + +this.A_4_7;
    },
    A_5_9: function A_5_9() {
      return +this.A_5_1 + +this.A_5_3 + +this.A_5_5 + +this.A_5_7;
    },
    A_6_9: function A_6_9() {
      return +this.A_6_1 + +this.A_6_3 + +this.A_6_5 + +this.A_6_7;
    },
    A_7_9: function A_7_9() {
      return +this.A_7_1 + +this.A_7_3 + +this.A_7_5 + +this.A_7_7;
    },
    A_8_9: function A_8_9() {
      return +this.A_8_1 + +this.A_8_3 + +this.A_8_5 + +this.A_8_7;
    },
    A_9a_9: function A_9a_9() {
      return +this.A_9a_1 + +this.A_9a_3 + +this.A_9a_5 + +this.A_9a_7;
    },
    A_9b_9: function A_9b_9() {
      return +this.A_9b_1 + +this.A_9b_3 + +this.A_9b_5 + +this.A_9b_7;
    },
    A_10_9: function A_10_9() {
      return +this.A_10_1 + +this.A_10_3 + +this.A_10_5 + +this.A_10_7;
    },
    A_11_9: function A_11_9() {
      return +this.A_11_1 + +this.A_11_3 + +this.A_11_5 + +this.A_11_7;
    },
    A_12_9: function A_12_9() {
      return +this.A_12_1 + +this.A_12_3 + +this.A_12_5 + +this.A_12_7;
    },
    A_13a_9: function A_13a_9() {
      return +this.A_13a_1 + +this.A_13a_3 + +this.A_13a_5 + +this.A_13a_7;
    },
    A_13b_9: function A_13b_9() {
      return +this.A_13b_1 + +this.A_13b_3 + +this.A_13b_5 + +this.A_13b_7;
    },
    A_13c_9: function A_13c_9() {
      return +this.A_13c_1 + +this.A_13c_3 + +this.A_13c_5 + +this.A_13c_7;
    },
    A_14_9: function A_14_9() {
      return +this.A_14_1 + +this.A_14_3 + +this.A_14_5 + +this.A_14_7;
    },
    A_15_9: function A_15_9() {
      return +this.A_15_1 + +this.A_15_3 + +this.A_15_5 + +this.A_15_7;
    },
    A_16_9: function A_16_9() {
      return +this.A_16_1 + +this.A_16_3 + +this.A_16_5 + +this.A_16_7;
    },
    A_17_9: function A_17_9() {
      return +this.A_17_1 + +this.A_17_3 + +this.A_17_5 + +this.A_17_7;
    },
    A_18_9: function A_18_9() {
      return +this.A_18_1 + +this.A_18_3 + +this.A_18_5 + +this.A_18_7;
    },
    A_19_9: function A_19_9() {
      return +this.A_19_1 + +this.A_19_3 + +this.A_19_5 + +this.A_19_7;
    },
    A_1_10: function A_1_10() {
      return +this.A_1_2 + +this.A_1_4 + +this.A_1_6 + +this.A_1_8;
    },
    A_2_10: function A_2_10() {
      return +this.A_2_2 + +this.A_2_4 + +this.A_2_6 + +this.A_2_8;
    },
    A_3_10: function A_3_10() {
      return +this.A_3_2 + +this.A_3_4 + +this.A_3_6 + +this.A_3_8;
    },
    A_4_10: function A_4_10() {
      return +this.A_4_2 + +this.A_4_4 + +this.A_4_6 + +this.A_4_8;
    },
    A_5_10: function A_5_10() {
      return +this.A_5_2 + +this.A_5_4 + +this.A_5_6 + +this.A_5_8;
    },
    A_6_10: function A_6_10() {
      return +this.A_6_2 + +this.A_6_4 + +this.A_6_6 + +this.A_6_8;
    },
    A_7_10: function A_7_10() {
      return +this.A_7_2 + +this.A_7_4 + +this.A_7_6 + +this.A_7_8;
    },
    A_8_10: function A_8_10() {
      return +this.A_8_2 + +this.A_8_4 + +this.A_8_6 + +this.A_8_8;
    },
    A_9a_10: function A_9a_10() {
      return +this.A_9a_2 + +this.A_9a_4 + +this.A_9a_6 + +this.A_9a_8;
    },
    A_9b_10: function A_9b_10() {
      return +this.A_9b_2 + +this.A_9b_4 + +this.A_9b_6 + +this.A_9b_8;
    },
    A_10_10: function A_10_10() {
      return +this.A_10_2 + +this.A_10_4 + +this.A_10_6 + +this.A_10_8;
    },
    A_11_10: function A_11_10() {
      return +this.A_11_2 + +this.A_11_4 + +this.A_11_6 + +this.A_11_8;
    },
    A_12_10: function A_12_10() {
      return +this.A_12_2 + +this.A_12_4 + +this.A_12_6 + +this.A_12_8;
    },
    A_13a_10: function A_13a_10() {
      return +this.A_13a_2 + +this.A_13a_4 + +this.A_13a_6 + +this.A_13a_8;
    },
    A_13b_10: function A_13b_10() {
      return +this.A_13b_2 + +this.A_13b_4 + +this.A_13b_6 + +this.A_13b_8;
    },
    A_13c_10: function A_13c_10() {
      return +this.A_13c_2 + +this.A_13c_4 + +this.A_13c_6 + +this.A_13c_8;
    },
    A_14_10: function A_14_10() {
      return +this.A_14_2 + +this.A_14_4 + +this.A_14_6 + +this.A_14_8;
    },
    A_15_10: function A_15_10() {
      return +this.A_15_2 + +this.A_15_4 + +this.A_15_6 + +this.A_15_8;
    },
    A_16_10: function A_16_10() {
      return +this.A_16_2 + +this.A_16_4 + +this.A_16_6 + +this.A_16_8;
    },
    A_17_10: function A_17_10() {
      return +this.A_17_2 + +this.A_17_4 + +this.A_17_6 + +this.A_17_8;
    },
    A_18_10: function A_18_10() {
      return +this.A_18_2 + +this.A_18_4 + +this.A_18_6 + +this.A_18_8;
    },
    A_19_10: function A_19_10() {
      return +this.A_19_2 + +this.A_19_4 + +this.A_19_6 + +this.A_19_8;
    },
    A_1_11: function A_1_11() {
      return +this.A_1_9 + +this.A_1_10;
    },
    A_2_11: function A_2_11() {
      return +this.A_2_9 + +this.A_2_10;
    },
    A_3_11: function A_3_11() {
      return +this.A_3_9 + +this.A_3_10;
    },
    A_4_11: function A_4_11() {
      return +this.A_4_9 + +this.A_4_10;
    },
    A_5_11: function A_5_11() {
      return +this.A_5_9 + +this.A_5_10;
    },
    A_6_11: function A_6_11() {
      return +this.A_6_9 + +this.A_6_10;
    },
    A_7_11: function A_7_11() {
      return +this.A_7_9 + +this.A_7_10;
    },
    A_8_11: function A_8_11() {
      return +this.A_8_9 + +this.A_8_10;
    },
    A_9a_11: function A_9a_11() {
      return +this.A_9a_9 + +this.A_9a_10;
    },
    A_9b_11: function A_9b_11() {
      return +this.A_9b_9 + +this.A_9b_10;
    },
    A_10_11: function A_10_11() {
      return +this.A_10_9 + +this.A_10_10;
    },
    A_11_11: function A_11_11() {
      return +this.A_11_9 + +this.A_11_10;
    },
    A_12_11: function A_12_11() {
      return +this.A_12_9 + +this.A_12_10;
    },
    A_13a_11: function A_13a_11() {
      return +this.A_13a_9 + +this.A_13a_10;
    },
    A_13b_11: function A_13b_11() {
      return +this.A_13b_9 + +this.A_13b_10;
    },
    A_13c_11: function A_13c_11() {
      return +this.A_13c_9 + +this.A_13c_10;
    },
    A_14_11: function A_14_11() {
      return +this.A_14_9 + +this.A_14_10;
    },
    A_15_11: function A_15_11() {
      return +this.A_15_9 + +this.A_15_10;
    },
    A_16_11: function A_16_11() {
      return +this.A_16_9 + +this.A_16_10;
    },
    A_17_11: function A_17_11() {
      return +this.A_17_9 + +this.A_17_10;
    },
    A_18_11: function A_18_11() {
      return +this.A_18_9 + +this.A_18_10;
    },
    A_19_11: function A_19_11() {
      return +this.A_19_9 + +this.A_19_10;
    },
    A_1_13: function A_1_13() {
      return +this.A_1_11 - +this.A_1_12;
    },
    A_2_13: function A_2_13() {
      return +this.A_2_11 - +this.A_2_12;
    },
    A_3_13: function A_3_13() {
      return +this.A_3_11 - +this.A_3_12;
    },
    A_4_13: function A_4_13() {
      return +this.A_4_11 - +this.A_4_12;
    },
    A_5_13: function A_5_13() {
      return +this.A_5_11 - +this.A_5_12;
    },
    A_6_13: function A_6_13() {
      return +this.A_6_11 - +this.A_6_12;
    },
    A_7_13: function A_7_13() {
      return +this.A_7_11 - +this.A_7_12;
    },
    A_8_13: function A_8_13() {
      return +this.A_8_11 - +this.A_8_12;
    },
    A_9a_13: function A_9a_13() {
      return +this.A_9a_11 - +this.A_9a_12;
    },
    A_9b_13: function A_9b_13() {
      return +this.A_9b_11 - +this.A_9b_12;
    },
    A_10_13: function A_10_13() {
      return +this.A_10_11 - +this.A_10_12;
    },
    A_11_13: function A_11_13() {
      return +this.A_11_11 - +this.A_11_12;
    },
    A_12_13: function A_12_13() {
      return +this.A_12_11 - +this.A_12_12;
    },
    A_13a_13: function A_13a_13() {
      return +this.A_13a_11 - +this.A_13a_12;
    },
    A_13b_13: function A_13b_13() {
      return +this.A_13b_11 - +this.A_13b_12;
    },
    A_13c_13: function A_13c_13() {
      return +this.A_13c_11 - +this.A_13c_12;
    },
    A_14_13: function A_14_13() {
      return +this.A_14_11 - +this.A_14_12;
    },
    A_15_13: function A_15_13() {
      return +this.A_15_11 - +this.A_15_12;
    },
    A_16_13: function A_16_13() {
      return +this.A_16_11 - +this.A_16_12;
    },
    A_17_13: function A_17_13() {
      return +this.A_17_11 - +this.A_17_12;
    },
    A_18_13: function A_18_13() {
      return +this.A_18_11 - +this.A_18_12;
    },
    A_19_13: function A_19_13() {
      return +this.A_19_11 - +this.A_19_12;
    },
    A_1_14: function A_1_14() {
      return +this.A_1_13 / (1 + this.sl) * this.sl;
    },
    A_2_14: function A_2_14() {
      return +this.A_2_13 / (1 + this.sl) * this.sl;
    },
    A_3_14: function A_3_14() {
      return +this.A_3_13 / (1 + this.sl) * this.sl;
    },
    A_4_14: function A_4_14() {
      return +this.A_4_13 / (1 + this.sl) * this.sl;
    },
    A_5_14: function A_5_14() {
      return +this.A_5_13 / (1 + this.sl) * this.sl;
    },
    A_6_14: function A_6_14() {
      return +this.A_6_13 / (1 + this.sl) * this.sl;
    },
    A_7_14: function A_7_14() {
      return +this.A_7_13 / (1 + this.sl) * this.sl;
    },
    A_8_14: function A_8_14() {
      return +this.A_8_13 / (1 + this.sl) * this.sl;
    },
    A_9a_14: function A_9a_14() {
      return +this.A_9a_13 / (1 + this.sl) * this.sl;
    },
    A_9b_14: function A_9b_14() {
      return +this.A_9b_13 / (1 + this.sl) * this.sl;
    },
    A_10_14: function A_10_14() {
      return +this.A_10_13 / (1 + this.sl) * this.sl;
    },
    A_11_14: function A_11_14() {
      return +this.A_11_13 / (1 + this.sl) * this.sl;
    },
    A_12_14: function A_12_14() {
      return +this.A_12_13 / (1 + this.sl) * this.sl;
    },
    A_13a_14: function A_13a_14() {
      return +this.A_13a_13 / (1 + this.sl) * this.sl;
    },
    A_13b_14: function A_13b_14() {
      return +this.A_13b_13 / (1 + this.sl) * this.sl;
    },
    A_13c_14: function A_13c_14() {
      return +this.A_13c_13 / (1 + this.sl) * this.sl;
    },
    A_14_14: function A_14_14() {
      return +this.A_14_13 / (1 + this.sl) * this.sl;
    },
    A_15_14: function A_15_14() {
      return +this.A_15_13 / (1 + this.sl) * this.sl;
    },
    A_16_14: function A_16_14() {
      return +this.A_16_13 / (1 + this.sl) * this.sl;
    },
    A_17_14: function A_17_14() {
      return +this.A_17_13 / (1 + this.sl) * this.sl;
    },
    A_18_14: function A_18_14() {
      return +this.A_18_13 / (1 + this.sl) * this.sl;
    },
    A_19_14: function A_19_14() {
      return +this.A_19_13 / (1 + +this.sl) * this.sl;
    }
  },
  methods: {
    arraySpanMethod: function arraySpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex % 2 === 0) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    objectSpanMethod: function objectSpanMethod(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      fs_2: 0,
      se_2: 0,
      je_2: 0,
      fs_3: 0,
      se_3: 0,
      je_3: 0,
      fs_5: 0,
      se_5: 0,
      je_5: 0,
      se_6: 0,
      fs_7: 0,
      se_7: 0,
      je_7: 0,
      se_8a: 0,
      je_8a: 0,
      fs_8a: 0,
      se_8b: 0,
      je_8b: 0,
      fs_8b: 0,
      fs_9: 0,
      se_9: 0,
      je_9: 0,
      fs_10: 0,
      se_10: 0,
      je_10: 0,
      fs_11: 0,
      se_11: 0,
      je_11: 0,
      fs_14: 0,
      se_14: 0,
      je_14: 0,
      fs_15: 0,
      se_15: 0,
      je_15: 0,
      fs_16: 0,
      se_16: 0,
      je_16: 0,
      fs_17: 0,
      se_17: 0,
      je_17: 0,
      fs_18: 0,
      se_18: 0,
      je_18: 0,
      fs_19: 0,
      se_19: 0,
      je_19: 0,
      fs_20: 0,
      se_20: 0,
      je_20: 0,
      fs_21: 0,
      se_21: 0,
      je_21: 0,
      fs_22: 0,
      se_22: 0,
      je_22: 0,
      fs_23: 0,
      se_23: 0,
      je_23: 0,
      fs_24: 0,
      se_24: 0,
      je_24: 0,
      fs_25: 0,
      se_25: 0,
      je_25: 0,
      fs_26: 0,
      se_26: 0,
      je_26: 0,
      fs_27: 0,
      se_27: 0,
      je_27: 0,
      fs_28: 0,
      se_28: 0,
      je_28: 0,
      fs_30: 0,
      se_30: 0,
      je_30: 0,
      fs_31: 0,
      se_31: 0,
      je_31: 0,
      fs_32: 0,
      se_32: 0,
      je_32: 0,
      fs_33: 0,
      se_33: 0,
      je_33: 0,
      fs_34: 0,
      se_34: 0,
      je_34: 0,
      fs_35: 0,
      se_35: 0,
      je_35: 0,
      fs_36: 0,
      se_36: 0,
      je_36: 0
    };
  },

  computed: {
    fs_4: function fs_4() {
      return +this.fs_5 + +this.fs_7 + +this.fs_8a;
    },
    se_4: function se_4() {
      return +this.se_5 + +this.se_6 + +this.se_7 + +this.se_8a + +this.se_8b;
    },
    je_4: function je_4() {
      return +this.je_5 + +this.je_7 + +this.je_8a + +this.je_8b;
    },
    fs_1: function fs_1() {
      return +this.fs_2 + +this.fs_3;
    },
    se_1: function se_1() {
      return +this.se_2 + +this.se_3;
    },
    je_1: function je_1() {
      return +this.je_2 + +this.je_3;
    },
    fs_12: function fs_12() {
      return +this.fs_1 + +this.fs_4 + +this.fs_11;
    },
    se_12: function se_12() {
      return +this.se_1 + +this.se_4 + +this.se_11;
    },
    je_12: function je_12() {
      return +this.je_1 + +this.je_4 + +this.je_11;
    },
    fs_29: function fs_29() {
      return +this.fs_30 + +this.fs_31 + +this.fs_32 + +this.fs_33 + +this.fs_34;
    },
    se_29: function se_29() {
      return;
      +this.se_30 + +this.se_31 + +this.se_32 + +this.se_33 + +this.se_34;
    },
    je_29: function je_29() {
      return +this.je_30 + +this.je_31 + +this.je_32 + +this.je_33 + +this.je_34;
    },
    fs_13: function fs_13() {
      return +this.fs_14 + +this.fs_15 + +this.fs_16 + +this.fs_17 + +this.fs_18 + +this.fs_19 + +this.fs_20 + +this.fs_21 + +this.fs_22 + +this.fs_23;
    },
    se_13: function se_13() {
      return;
      +this.se_14 + +this.se_15 + +this.se_16 + +this.se_17 + +this.se_18 + +this.se_19 + +this.se_20 + +this.se_21 + +this.se_22 + +this.se_23;
    },
    je_13: function je_13() {
      return;
      +this.je_14 + +this.je_15 + +this.je_16 + +this.je_17 + +this.je_18 + +this.je_19 + +this.je_20 + +this.je_21 + +this.je_22 + +this.je_23;
    }
  },
  methods: {}
};

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(347);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      A_1_1: 0,
      A_1_2: 0,
      A_1_3: 0,
      A_2_1: 0,
      A_2_2: 0,
      A_2_3: 0,
      A_3_1: 0,
      A_3_2: 0,
      A_3_3: 0
    }, (0, _defineProperty3.default)(_ref, "A_3_1", 0), (0, _defineProperty3.default)(_ref, "A_3_2", 0), (0, _defineProperty3.default)(_ref, "A_3_3", 0), (0, _defineProperty3.default)(_ref, "A_4_1", 0), (0, _defineProperty3.default)(_ref, "A_4_2", 0), (0, _defineProperty3.default)(_ref, "A_4_3", 0), (0, _defineProperty3.default)(_ref, "A_5_1", 0), (0, _defineProperty3.default)(_ref, "A_5_2", 0), (0, _defineProperty3.default)(_ref, "A_5_3", 0), (0, _defineProperty3.default)(_ref, "A_6_1", 0), (0, _defineProperty3.default)(_ref, "A_6_2", 0), (0, _defineProperty3.default)(_ref, "A_6_3", 0), (0, _defineProperty3.default)(_ref, "A_7_1", 0), (0, _defineProperty3.default)(_ref, "A_7_2", 0), (0, _defineProperty3.default)(_ref, "A_7_3", 0), (0, _defineProperty3.default)(_ref, "A_8_1", 0), (0, _defineProperty3.default)(_ref, "A_8_2", 0), (0, _defineProperty3.default)(_ref, "A_8_3", 0), _ref;
  },

  computed: {
    A_1_4: function A_1_4() {
      return +this.A_1_2 + +this.A_1_3;
    },
    A_2_4: function A_2_4() {
      return +this.A_2_2 + +this.A_2_3;
    },
    A_3_4: function A_3_4() {
      return +this.A_3_2 + +this.A_3_3;
    },
    A_4_4: function A_4_4() {
      return +this.A_4_2 + +this.A_4_3;
    },
    A_5_4: function A_5_4() {
      return +this.A_5_2 + +this.A_5_3;
    },
    A_6_4: function A_6_4() {
      return +this.A_6_2 + +this.A_6_3;
    },
    A_7_4: function A_7_4() {
      return +this.A_7_2 + +this.A_7_3;
    },
    A_8_4: function A_8_4() {
      return +this.A_8_2 + +this.A_8_3;
    },
    A_1_5: function A_1_5() {
      return +this.A_1_1 < +this.A_1_4 ? +this.A_1_1 : +this.A_1_4;
    },
    A_2_5: function A_2_5() {
      return +this.A_2_1 < +this.A_2_4 ? +this.A_2_1 : +this.A_2_4;
    },
    A_3_5: function A_3_5() {
      return +this.A_3_1 < +this.A_3_4 ? +this.A_3_1 : +this.A_3_4;
    },
    A_4_5: function A_4_5() {
      return +this.A_4_1 < +this.A_4_4 ? +this.A_4_1 : +this.A_4_4;
    },
    A_5_5: function A_5_5() {
      return +this.A_5_1 < +this.A_5_4 ? +this.A_5_1 : +this.A_5_4;
    },
    A_6_5: function A_6_5() {
      return +this.A_6_1 < +this.A_6_4 ? +this.A_6_1 : +this.A_6_4;
    },
    A_7_5: function A_7_5() {
      return +this.A_7_1 < +this.A_7_4 ? +this.A_7_1 : +this.A_7_4;
    },
    A_8_5: function A_8_5() {
      return +this.A_8_1 < +this.A_8_4 ? +this.A_8_1 : +this.A_8_4;
    },
    A_1_6: function A_1_6() {
      return +this.A_1_4 - +this.A_1_5;
    },
    A_2_6: function A_2_6() {
      return +this.A_2_4 - +this.A_2_5;
    },
    A_3_6: function A_3_6() {
      return +this.A_3_4 - +this.A_3_5;
    },
    A_4_6: function A_4_6() {
      return +this.A_4_4 - +this.A_4_5;
    },
    A_5_6: function A_5_6() {
      return +this.A_5_4 - +this.A_5_5;
    },
    A_6_6: function A_6_6() {
      return +this.A_6_4 - +this.A_6_5;
    },
    A_7_6: function A_7_6() {
      return +this.A_7_4 - +this.A_7_5;
    },
    A_8_6: function A_8_6() {
      return +this.A_8_4 - +this.A_8_5;
    }
  },
  methods: {}
};

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      A_1_1: 0, A_1_2: 0, A_1_4: 0,
      A_2_1: 0, A_2_2: 0, A_2_4: 0,
      A_3_1: 0, A_3_2: 0, A_3_4: 0,
      A_4_1: 0, A_4_2: 0, A_4_4: 0,
      A_5_1: 0, A_5_2: 0, A_5_4: 0,
      A_6_1: 0, A_6_2: 0, A_6_3: 0, A_6_5: 0,
      A_7_1: 0, A_7_2: 0, A_7_3: 0, A_7_5: 0,
      A_8_1: 0, A_8_2: 0, A_8_3: 0, A_8_5: 0
    };
  },

  computed: {
    A_1_3: function A_1_3() {
      return +this.A_1_1 + +this.A_1_2;
    },
    A_2_3: function A_2_3() {
      return +this.A_2_1 + +this.A_2_2;
    },
    A_3_3: function A_3_3() {
      return +this.A_3_1 + +this.A_3_2;
    },
    A_4_3: function A_4_3() {
      return +this.A_4_1 + +this.A_4_2;
    },
    A_5_3: function A_5_3() {
      return +this.A_5_1 + +this.A_5_2;
    },
    A_1_5: function A_1_5() {
      return +this.A_1_3 - +this.A_1_4;
    },
    A_2_5: function A_2_5() {
      return +this.A_2_3 - +this.A_2_4;
    },
    A_3_5: function A_3_5() {
      return +this.A_3_3 - +this.A_3_4;
    },
    A_4_5: function A_4_5() {
      return +this.A_4_3 - +this.A_4_4;
    },
    A_5_5: function A_5_5() {
      return +this.A_5_3 - +this.A_5_4;
    },
    A_6_6: function A_6_6() {
      return +this.A_6_4 - +this.A_6_5;
    },
    A_7_6: function A_7_6() {
      return +this.A_7_4 - +this.A_7_5;
    },
    A_8_6: function A_8_6() {
      return +this.A_8_4 - +this.A_8_5;
    },
    A_6_4: function A_6_4() {
      return +this.A_6_1 + +this.A_6_2 + +this.A_6_3;
    },
    A_7_4: function A_7_4() {
      return +this.A_7_1 + +this.A_7_2 + +this.A_7_3;
    },
    A_8_4: function A_8_4() {
      return +this.A_8_1 + +this.A_8_2 + +this.A_8_3;
    }
  },
  methods: {}
};

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(20);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(274);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(271);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(272);

var _vueRouter = __webpack_require__(275);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(270);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(106);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(269);

var _routes2 = _interopRequireDefault(_routes);

var _mock = __webpack_require__(268);

var _mock2 = _interopRequireDefault(_mock);

__webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_mock2.default.bootstrap();


_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

var router = new _vueRouter2.default({
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
  }
  var user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.a = undefined;

var _mockjs = __webpack_require__(247);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var a = [];

for (var i = 0; i < 10; i++) {
  a.push(_mockjs2.default.mock({
    id: _mockjs2.default.Random.id(),
    companyCode: _mockjs2.default.mock('@string()'),
    companyName: _mockjs2.default.mock('@ctitle(3, 5)'),
    code: _mockjs2.default.mock('@word(13)'),
    name: _mockjs2.default.mock('@ctitle(3, 5)'),
    "jsfs|1": ["一般计税", "免税", "简易计税"],
    "sfjs|1": ["是", "否"],
    "sfhs|1": ["是", "否"],
    "taxRate|1": ["0%", "3%", "6%", "10%", "16%"],
    "sfjzjt|1": ["是", "否"],
    "kpgz|1": ["增值税普通发票", "增值税专用发票", "不开票"],
    goodsCode: _mockjs2.default.mock('@string()'),
    goodsName: _mockjs2.default.mock('@string()'),
    rowIndex: _mockjs2.default.Random.integer(0, 200),
    "tableName|1": ["主表", "附表一", "附表二", "附表三", "附表四"],
    "isEnable|1": ["是", "否"]
  }));
}

exports.a = a;

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Users = exports.LoginUsers = undefined;

var _mockjs = __webpack_require__(247);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginUsers = [{
  id: 1,
  username: 'admin',
  password: '123456',
  avatar: 'https://pic.cnblogs.com/avatar/938653/20180604173435.png',
  name: '管理员'
}];

var Users = [];

for (var i = 0; i < 86; i++) {
  Users.push(_mockjs2.default.mock({
    id: _mockjs2.default.Random.guid(),
    name: _mockjs2.default.Random.cname(),
    addr: _mockjs2.default.mock('@county(true)'),
    'age|18-60': 1,
    birth: _mockjs2.default.Random.date(),
    sex: _mockjs2.default.Random.integer(0, 1)
  }));
}

exports.LoginUsers = LoginUsers;
exports.Users = Users;

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(348);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(164);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(344);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(107);

var _axios2 = _interopRequireDefault(_axios);

var _axiosMockAdapter = __webpack_require__(299);

var _axiosMockAdapter2 = _interopRequireDefault(_axiosMockAdapter);

var _user = __webpack_require__(338);

var _a = __webpack_require__(337);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _A = _a.a;
var _Users = _user.Users;

exports.default = {
  bootstrap: function bootstrap() {
    var mock = new _axiosMockAdapter2.default(_axios2.default);

    mock.onGet('/success').reply(200, {
      msg: 'success'
    });

    mock.onGet('/error').reply(500, {
      msg: 'failure'
    });

    mock.onPost('/login').reply(function (config) {
      var _JSON$parse = JSON.parse(config.data),
          username = _JSON$parse.username,
          password = _JSON$parse.password;

      return new _promise2.default(function (resolve, reject) {
        var user = null;
        setTimeout(function () {
          var hasUser = _user.LoginUsers.some(function (u) {
            if (u.username === username && u.password === password) {
              user = JSON.parse((0, _stringify2.default)(u));
              user.password = undefined;
              return true;
            }
          });

          if (hasUser) {
            resolve([200, { code: 200, msg: '请求成功', user: user }]);
          } else {
            resolve([200, { code: 500, msg: '账号或密码错误' }]);
          }
        }, 1000);
      });
    });

    mock.onGet('/user/list').reply(function (config) {
      var name = config.params.name;

      var mockUsers = _Users.filter(function (user) {
        if (name && user.name.indexOf(name) == -1) return false;
        return true;
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            users: mockUsers
          }]);
        }, 1000);
      });
    });

    mock.onGet('/user/listpage').reply(function (config) {
      var _config$params = config.params,
          page = _config$params.page,
          name = _config$params.name;

      var mockUsers = _Users.filter(function (user) {
        if (name && user.name.indexOf(name) == -1) return false;
        return true;
      });
      var total = mockUsers.length;
      mockUsers = mockUsers.filter(function (u, index) {
        return index < 20 * page && index >= 20 * (page - 1);
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            total: total,
            users: mockUsers
          }]);
        }, 1000);
      });
    });

    mock.onGet('/user/remove').reply(function (config) {
      var id = config.params.id;

      _Users = _Users.filter(function (u) {
        return u.id !== id;
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/user/batchremove').reply(function (config) {
      var ids = config.params.ids;

      ids = ids.split(',');
      _Users = _Users.filter(function (u) {
        return !ids.includes(u.id);
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/user/edit').reply(function (config) {
      var _config$params2 = config.params,
          id = _config$params2.id,
          name = _config$params2.name,
          addr = _config$params2.addr,
          age = _config$params2.age,
          birth = _config$params2.birth,
          sex = _config$params2.sex;

      _Users.some(function (u) {
        if (u.id === id) {
          u.name = name;
          u.addr = addr;
          u.age = age;
          u.birth = birth;
          u.sex = sex;
          return true;
        }
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '编辑成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/user/add').reply(function (config) {
      var _config$params3 = config.params,
          name = _config$params3.name,
          addr = _config$params3.addr,
          age = _config$params3.age,
          birth = _config$params3.birth,
          sex = _config$params3.sex;

      _Users.push({
        name: name,
        addr: addr,
        age: age,
        birth: birth,
        sex: sex
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '新增成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/a/get').reply(function (config) {
      var _config$params4 = config.params,
          page = _config$params4.page,
          name = _config$params4.name;

      var res = _A.filter(function (x) {
        if (name && x.companyName.indexOf(name) == -1) return false;
        return true;
      });
      var total = res.length;
      res = res.filter(function (u, index) {
        return index < 100 * page && index >= 100 * (page - 1);
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            total: total,
            list: res
          }]);
        }, 1000);
      });
    });
    mock.onGet('/a/add').reply(function (config) {
      _A.push(config.params);
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '新增成功'
          }]);
        }, 500);
      });
    });
    mock.onGet('/a/edit').reply(function (config) {
      _A.some(function (u) {
        if (u.id === id) {
          for (var o in u) {
            var tag = config.params[o];
            if (tag) u[o] = tag;
          }
          return true;
        }
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '修改成功'
          }]);
        }, 500);
      });
    });
    mock.onGet('/a/del').reply(function (config) {
      var id = config.params.id;

      _A = _A.filter(function (u) {
        return id !== u.id;
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }]);
        }, 500);
      });
    });
    mock.onGet('/a/save').reply(function (config) {
      var _A2;

      debugger;
      var toadd = config.params.filter(function (m) {
        return m.state == "new";
      });
      toadd.forEach(function (element) {
        element.state = "normal";
      });
      (_A2 = _A).push.apply(_A2, (0, _toConsumableArray3.default)(toadd));
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '保存成功'
          }]);
        }, 500);
      });
    });
  }
};

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveA = exports.editA = exports.removeA = exports.addA = exports.getA = exports.addUser = exports.editUser = exports.batchRemoveUser = exports.removeUser = exports.getUserListPage = exports.getUserList = exports.requestLogin = undefined;

var _axios = __webpack_require__(107);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = '';

var requestLogin = exports.requestLogin = function requestLogin(params) {
  return _axios2.default.post(base + '/login', params).then(function (res) {
    return res.data;
  });
};

var getUserList = exports.getUserList = function getUserList(params) {
  return _axios2.default.get(base + '/user/list', { params: params });
};

var getUserListPage = exports.getUserListPage = function getUserListPage(params) {
  return _axios2.default.get(base + '/user/listpage', { params: params });
};

var removeUser = exports.removeUser = function removeUser(params) {
  return _axios2.default.get(base + '/user/remove', { params: params });
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
  return _axios2.default.get(base + '/user/batchremove', { params: params });
};

var editUser = exports.editUser = function editUser(params) {
  return _axios2.default.get(base + '/user/edit', { params: params });
};

var addUser = exports.addUser = function addUser(params) {
  return _axios2.default.get(base + '/user/add', { params: params });
};

var getA = exports.getA = function getA(params) {
  return _axios2.default.get(base + '/a/get', { params: params });
};
var addA = exports.addA = function addA(params) {
  return _axios2.default.get(base + '/a/add', { params: params });
};
var removeA = exports.removeA = function removeA(params) {
  return _axios2.default.get(base + '/a/del', { params: params });
};
var editA = exports.editA = function editA(params) {
  return _axios2.default.get(base + '/a/edit', { params: params });
};
var saveA = exports.saveA = function saveA(params) {
  return _axios2.default.get(base + '/a/save', { params: params });
};

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

};

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(669)

var Component = __webpack_require__(9)(
  /* script */
  null,
  /* template */
  __webpack_require__(717),
  /* scopeId */
  "data-v-444ec691",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(671)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  "data-v-68169514",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(670)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  "data-v-5ef2403c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(668)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(714),
  /* scopeId */
  "data-v-2f226d60",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(678)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(728),
  /* scopeId */
  "data-v-ea81cb12",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(725),
  /* scopeId */
  "data-v-a0d313d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(674)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(724),
  /* scopeId */
  "data-v-a0b6e4d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(673)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(723),
  /* scopeId */
  "data-v-a09ab5ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(672)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  "data-v-a07e86cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(663)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  "data-v-134397f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(677)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(727),
  /* scopeId */
  "data-v-d6411736",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  null,
  /* template */
  __webpack_require__(716),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  null,
  /* template */
  __webpack_require__(720),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(726),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(667)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  "data-v-24a079d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(666)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  "data-v-24844ad0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(665)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  "data-v-24681bce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(664)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(710),
  /* scopeId */
  "data-v-244beccc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 708:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "生日",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "地址",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sex", $$v)
      },
      expression: "editForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.editForm.age),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "age", $$v)
      },
      expression: "editForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "birth", $$v)
      },
      expression: "editForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "addr", $$v)
      },
      expression: "editForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sex", $$v)
      },
      expression: "addForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.addForm.age),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "age", $$v)
      },
      expression: "addForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.addForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "birth", $$v)
      },
      expression: "addForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "addr", $$v)
      },
      expression: "addForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "tftable",
    attrs: {
      "id": "tfhover",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("增值税税控系统专用设备费及技术维护费（来源减免税明细台账）")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_1),
      expression: "A_1_1"
    }],
    domProps: {
      "value": (_vm.A_1_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_2),
      expression: "A_1_2"
    }],
    domProps: {
      "value": (_vm.A_1_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_1_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_4),
      expression: "A_1_4"
    }],
    domProps: {
      "value": (_vm.A_1_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_1_5))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("分支机构预征缴纳税款 ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_1),
      expression: "A_2_1"
    }],
    domProps: {
      "value": (_vm.A_2_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_2),
      expression: "A_2_2"
    }],
    domProps: {
      "value": (_vm.A_2_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_2_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_4),
      expression: "A_2_4"
    }],
    domProps: {
      "value": (_vm.A_2_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_2_5))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("建筑服务预征缴纳税款 ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_1),
      expression: "A_3_1"
    }],
    domProps: {
      "value": (_vm.A_3_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_2),
      expression: "A_3_2"
    }],
    domProps: {
      "value": (_vm.A_3_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_3_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_4),
      expression: "A_3_4"
    }],
    domProps: {
      "value": (_vm.A_3_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_3_5))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("销售不动产预征缴纳税款 ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_1),
      expression: "A_4_1"
    }],
    domProps: {
      "value": (_vm.A_4_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_2),
      expression: "A_4_2"
    }],
    domProps: {
      "value": (_vm.A_4_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_4_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_4),
      expression: "A_4_4"
    }],
    domProps: {
      "value": (_vm.A_4_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_4_5))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("出租不动产预征缴纳税款")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_1),
      expression: "A_5_1"
    }],
    domProps: {
      "value": (_vm.A_5_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_2),
      expression: "A_5_2"
    }],
    domProps: {
      "value": (_vm.A_5_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_5_3))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_4),
      expression: "A_5_4"
    }],
    domProps: {
      "value": (_vm.A_5_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.A_5_5))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("一般项目加计抵减额计算")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_1),
      expression: "A_6_1"
    }],
    domProps: {
      "value": (_vm.A_6_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_2),
      expression: "A_6_2"
    }],
    domProps: {
      "value": (_vm.A_6_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_3),
      expression: "A_6_3"
    }],
    domProps: {
      "value": (_vm.A_6_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_6_4))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_5),
      expression: "A_6_5"
    }],
    domProps: {
      "value": (_vm.A_6_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_6_6))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("即征即退项目加计抵减额计算")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_1),
      expression: "A_7_1"
    }],
    domProps: {
      "value": (_vm.A_7_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_2),
      expression: "A_7_2"
    }],
    domProps: {
      "value": (_vm.A_7_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_3),
      expression: "A_7_3"
    }],
    domProps: {
      "value": (_vm.A_7_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_7_4))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_5),
      expression: "A_7_5"
    }],
    domProps: {
      "value": (_vm.A_7_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_7_6))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_1),
      expression: "A_8_1"
    }],
    domProps: {
      "value": (_vm.A_8_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_2),
      expression: "A_8_2"
    }],
    domProps: {
      "value": (_vm.A_8_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_3),
      expression: "A_8_3"
    }],
    domProps: {
      "value": (_vm.A_8_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_8_4))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_5),
      expression: "A_8_5"
    }],
    domProps: {
      "value": (_vm.A_8_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.A_8_6))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("增值税纳税申报表附列资料（四）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("（税额抵减情况表）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("税款所属时间： 年 月 日 至 年 月 日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("纳税人名称：（公章）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("金额单位：元至角分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("抵减项目")]), _vm._v(" "), _c('td', [_vm._v("期初余额")]), _vm._v(" "), _c('td', [_vm._v("本期发生额")]), _vm._v(" "), _c('td', [_vm._v("本期应抵减税额")]), _vm._v(" "), _c('td', [_vm._v("本期实际抵减税额")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("期末余额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3=1+2")]), _vm._v(" "), _c('td', [_vm._v("4≤3")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("5=3-4")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("二、加计抵减情况")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("抵减项目")]), _vm._v(" "), _c('td', [_vm._v("期初余额")]), _vm._v(" "), _c('td', [_vm._v("本期发生额")]), _vm._v(" "), _c('td', [_vm._v("本期应抵减税额")]), _vm._v(" "), _c('td', [_vm._v("本期实际抵减税额")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("期末余额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4=1+2-3")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("6=4-5")])])
}]}

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "tftable",
    attrs: {
      "id": "tfhover",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('tr', [_c('td', [_vm._v("13%税率的项目")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_1),
      expression: "A_1_1"
    }],
    domProps: {
      "value": (_vm.A_1_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_2),
      expression: "A_1_2"
    }],
    domProps: {
      "value": (_vm.A_1_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_3),
      expression: "A_1_3"
    }],
    domProps: {
      "value": (_vm.A_1_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.A_1_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_1_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_1_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9%税率的项目")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_1),
      expression: "A_2_1"
    }],
    domProps: {
      "value": (_vm.A_2_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_2),
      expression: "A_2_2"
    }],
    domProps: {
      "value": (_vm.A_2_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_3),
      expression: "A_2_3"
    }],
    domProps: {
      "value": (_vm.A_2_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_2_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_2_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_2_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6%税率的项目（不含金融商品转让）")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_1),
      expression: "A_3_1"
    }],
    domProps: {
      "value": (_vm.A_3_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_2),
      expression: "A_3_2"
    }],
    domProps: {
      "value": (_vm.A_3_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_3),
      expression: "A_3_3"
    }],
    domProps: {
      "value": (_vm.A_3_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_3_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_3_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_3_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6%税率的金融商品转让项目")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_1),
      expression: "A_4_1"
    }],
    domProps: {
      "value": (_vm.A_4_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_2),
      expression: "A_4_2"
    }],
    domProps: {
      "value": (_vm.A_4_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_3),
      expression: "A_4_3"
    }],
    domProps: {
      "value": (_vm.A_4_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_4_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_4_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_4_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5%征收率的项目")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_1),
      expression: "A_5_1"
    }],
    domProps: {
      "value": (_vm.A_5_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_2),
      expression: "A_5_2"
    }],
    domProps: {
      "value": (_vm.A_5_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_3),
      expression: "A_5_3"
    }],
    domProps: {
      "value": (_vm.A_5_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_5_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_5_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_5_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3%征收率的项目")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_1),
      expression: "A_6_1"
    }],
    domProps: {
      "value": (_vm.A_6_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_2),
      expression: "A_6_2"
    }],
    domProps: {
      "value": (_vm.A_6_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_3),
      expression: "A_6_3"
    }],
    domProps: {
      "value": (_vm.A_6_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_6_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_6_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_6_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("免抵退税的项目")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_1),
      expression: "A_7_1"
    }],
    domProps: {
      "value": (_vm.A_7_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_2),
      expression: "A_7_2"
    }],
    domProps: {
      "value": (_vm.A_7_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_3),
      expression: "A_7_3"
    }],
    domProps: {
      "value": (_vm.A_7_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_7_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_7_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_7_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("免税的项目")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_1),
      expression: "A_8_1"
    }],
    domProps: {
      "value": (_vm.A_8_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_2),
      expression: "A_8_2"
    }],
    domProps: {
      "value": (_vm.A_8_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_3),
      expression: "A_8_3"
    }],
    domProps: {
      "value": (_vm.A_8_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_8_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_8_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_8_6) + "\n      ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("增值税纳税申报表附列资料（三）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("（服务、不动产和无形资产扣除项目明细）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("税款所属时间： 年 月 日 至 年 月 日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("纳税人名称：（公章）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("金额单位：元至角分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2",
      "rowspan": "3"
    }
  }, [_vm._v("项目及栏次")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("本期服务、不动产和无形资产价税合计额（免税销售额）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("服务、不动产和无形资产扣除项目")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("期初余额")]), _vm._v(" "), _c('td', [_vm._v("本期发生额")]), _vm._v(" "), _c('td', [_vm._v("本期应扣除金额")]), _vm._v(" "), _c('td', [_vm._v("本期实际扣除金额")]), _vm._v(" "), _c('td', [_vm._v("期末余额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4=2+3")]), _vm._v(" "), _c('td', [_vm._v("5(5≤1且5≤4)")]), _vm._v(" "), _c('td', [_vm._v("6=4-5")])])
}]}

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "tftable",
    attrs: {
      "id": "tfhover",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（一）认证相符的增值税专用发票")]), _vm._v(" "), _c('td', [_vm._v("1=2+3")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_1),
      expression: "fs_1"
    }],
    domProps: {
      "value": (_vm.fs_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_1),
      expression: "je_1"
    }],
    domProps: {
      "value": (_vm.je_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_1),
      expression: "se_1"
    }],
    domProps: {
      "value": (_vm.se_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：本期认证相符且本期申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_2),
      expression: "fs_2"
    }],
    domProps: {
      "value": (_vm.fs_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_2),
      expression: "je_2"
    }],
    domProps: {
      "value": (_vm.je_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_2),
      expression: "se_2"
    }],
    domProps: {
      "value": (_vm.se_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("前期认证相符且本期申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_3),
      expression: "fs_3"
    }],
    domProps: {
      "value": (_vm.fs_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_3),
      expression: "je_3"
    }],
    domProps: {
      "value": (_vm.je_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_3),
      expression: "se_3"
    }],
    domProps: {
      "value": (_vm.se_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_3 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（二）其他扣税凭证")]), _vm._v(" "), _c('td', [_vm._v("4=5+6+7+8a+8b")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_4),
      expression: "fs_4"
    }],
    domProps: {
      "value": (_vm.fs_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_4),
      expression: "je_4"
    }],
    domProps: {
      "value": (_vm.je_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_4),
      expression: "se_4"
    }],
    domProps: {
      "value": (_vm.se_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_4 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：海关进口增值税专用缴款书")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_5),
      expression: "fs_5"
    }],
    domProps: {
      "value": (_vm.fs_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_5),
      expression: "je_5"
    }],
    domProps: {
      "value": (_vm.je_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_5),
      expression: "se_5"
    }],
    domProps: {
      "value": (_vm.se_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_5 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("农产品收购发票或者销售发票")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("不填写")]), _vm._v(" "), _c('td', [_vm._v("不填写")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_6),
      expression: "se_6"
    }],
    domProps: {
      "value": (_vm.se_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_6 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("代扣代缴税收缴款凭证")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_7),
      expression: "fs_7"
    }],
    domProps: {
      "value": (_vm.fs_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_7),
      expression: "je_7"
    }],
    domProps: {
      "value": (_vm.je_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_7),
      expression: "se_7"
    }],
    domProps: {
      "value": (_vm.se_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_7 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("加计扣除农产品进项税额")]), _vm._v(" "), _c('td', [_vm._v("8a")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_8a),
      expression: "fs_8a"
    }],
    domProps: {
      "value": (_vm.fs_8a)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_8a = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_8a),
      expression: "je_8a"
    }],
    domProps: {
      "value": (_vm.je_8a)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_8a = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_8a),
      expression: "se_8a"
    }],
    domProps: {
      "value": (_vm.se_8a)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_8a = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他")]), _vm._v(" "), _c('td', [_vm._v("8b")]), _vm._v(" "), _c('td', [_vm._v("不填写")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_8b),
      expression: "je_8b"
    }],
    domProps: {
      "value": (_vm.je_8b)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_8b = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_8b),
      expression: "se_8b"
    }],
    attrs: {
      "title": "/2、通行费、旅客运输服务台账可抵扣进项税额填入该栏"
    },
    domProps: {
      "value": (_vm.se_8b)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_8b = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（三）本期用于购建不动产的扣税凭证")]), _vm._v(" "), _c('td', [_vm._v("9")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_9),
      expression: "fs_9"
    }],
    domProps: {
      "value": (_vm.fs_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_9),
      expression: "je_9"
    }],
    domProps: {
      "value": (_vm.je_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_9),
      expression: "se_9"
    }],
    domProps: {
      "value": (_vm.se_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_9 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（四）本期用于抵扣的旅客运输服务扣税凭证")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_10),
      expression: "fs_10"
    }],
    domProps: {
      "value": (_vm.fs_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_10),
      expression: "je_10"
    }],
    domProps: {
      "value": (_vm.je_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_10),
      expression: "se_10"
    }],
    domProps: {
      "value": (_vm.se_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_10 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（五）外贸企业进项税额抵扣证明")]), _vm._v(" "), _c('td', [_vm._v("11")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_11),
      expression: "fs_11"
    }],
    domProps: {
      "value": (_vm.fs_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_11),
      expression: "je_11"
    }],
    domProps: {
      "value": (_vm.je_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_11),
      expression: "se_11"
    }],
    domProps: {
      "value": (_vm.se_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_11 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("当期申报抵扣进项税额合计")]), _vm._v(" "), _c('td', [_vm._v("12")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_12),
      expression: "fs_12"
    }],
    domProps: {
      "value": (_vm.fs_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_12),
      expression: "je_12"
    }],
    domProps: {
      "value": (_vm.je_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_12),
      expression: "se_12"
    }],
    domProps: {
      "value": (_vm.se_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_12 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('tr', [_c('td', [_vm._v("本期进项税额转出额")]), _vm._v(" "), _c('td', [_vm._v("13=14至23之和")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_13),
      expression: "fs_13"
    }],
    domProps: {
      "value": (_vm.fs_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_13),
      expression: "je_13"
    }],
    domProps: {
      "value": (_vm.je_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_13),
      expression: "se_13"
    }],
    domProps: {
      "value": (_vm.se_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_13 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：免税项目用")]), _vm._v(" "), _c('td', [_vm._v("14")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_14),
      expression: "fs_14"
    }],
    domProps: {
      "value": (_vm.fs_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_14 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_14),
      expression: "je_14"
    }],
    domProps: {
      "value": (_vm.je_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_14 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_14),
      expression: "se_14"
    }],
    domProps: {
      "value": (_vm.se_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("集体福利、个人消费")]), _vm._v(" "), _c('td', [_vm._v("15")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_15),
      expression: "fs_15"
    }],
    domProps: {
      "value": (_vm.fs_15)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_15 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_15),
      expression: "je_15"
    }],
    domProps: {
      "value": (_vm.je_15)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_15 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_15),
      expression: "se_15"
    }],
    domProps: {
      "value": (_vm.se_15)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_15 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("非正常损失")]), _vm._v(" "), _c('td', [_vm._v("16")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_16),
      expression: "fs_16"
    }],
    domProps: {
      "value": (_vm.fs_16)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_16 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_16),
      expression: "je_16"
    }],
    domProps: {
      "value": (_vm.je_16)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_16 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_16),
      expression: "se_16"
    }],
    domProps: {
      "value": (_vm.se_16)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_16 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("简易计税方法征税项目用")]), _vm._v(" "), _c('td', [_vm._v("17")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_17),
      expression: "fs_17"
    }],
    domProps: {
      "value": (_vm.fs_17)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_17 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_17),
      expression: "je_17"
    }],
    domProps: {
      "value": (_vm.je_17)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_17 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_17),
      expression: "se_17"
    }],
    domProps: {
      "value": (_vm.se_17)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_17 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("免抵退税办法不得抵扣的进项税额")]), _vm._v(" "), _c('td', [_vm._v("18")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_18),
      expression: "fs_18"
    }],
    domProps: {
      "value": (_vm.fs_18)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_18 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_18),
      expression: "je_18"
    }],
    domProps: {
      "value": (_vm.je_18)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_18 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_18),
      expression: "se_18"
    }],
    domProps: {
      "value": (_vm.se_18)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_18 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("纳税检查调减进项税额")]), _vm._v(" "), _c('td', [_vm._v("19")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_19),
      expression: "fs_19"
    }],
    domProps: {
      "value": (_vm.fs_19)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_19 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_19),
      expression: "je_19"
    }],
    domProps: {
      "value": (_vm.je_19)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_19 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_19),
      expression: "se_19"
    }],
    domProps: {
      "value": (_vm.se_19)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_19 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("红字专用发票信息表注明的进项税额")]), _vm._v(" "), _c('td', [_vm._v("20")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_20),
      expression: "fs_20"
    }],
    domProps: {
      "value": (_vm.fs_20)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_20 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_20),
      expression: "je_20"
    }],
    domProps: {
      "value": (_vm.je_20)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_20 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_20),
      expression: "se_20"
    }],
    domProps: {
      "value": (_vm.se_20)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_20 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("上期留抵税额抵减欠税")]), _vm._v(" "), _c('td', [_vm._v("21")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_21),
      expression: "fs_21"
    }],
    domProps: {
      "value": (_vm.fs_21)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_21 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_21),
      expression: "je_21"
    }],
    domProps: {
      "value": (_vm.je_21)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_21 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_21),
      expression: "se_21"
    }],
    domProps: {
      "value": (_vm.se_21)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_21 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("上期留抵税额退税")]), _vm._v(" "), _c('td', [_vm._v("22")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_22),
      expression: "fs_22"
    }],
    domProps: {
      "value": (_vm.fs_22)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_22 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_22),
      expression: "je_22"
    }],
    domProps: {
      "value": (_vm.je_22)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_22 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_22),
      expression: "se_22"
    }],
    domProps: {
      "value": (_vm.se_22)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_22 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他应作进项税额转出的情形")]), _vm._v(" "), _c('td', [_vm._v("23")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_23),
      expression: "fs_23"
    }],
    domProps: {
      "value": (_vm.fs_23)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_23 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_23),
      expression: "je_23"
    }],
    domProps: {
      "value": (_vm.je_23)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_23 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_23),
      expression: "se_23"
    }],
    domProps: {
      "value": (_vm.se_23)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_23 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（一）认证相符的增值税专用发票")]), _vm._v(" "), _c('td', [_vm._v("24")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_24),
      expression: "fs_24"
    }],
    domProps: {
      "value": (_vm.fs_24)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_24 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_24),
      expression: "je_24"
    }],
    domProps: {
      "value": (_vm.je_24)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_24 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_24),
      expression: "se_24"
    }],
    domProps: {
      "value": (_vm.se_24)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_24 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("期初已认证相符但未申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("25")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_25),
      expression: "fs_25"
    }],
    domProps: {
      "value": (_vm.fs_25)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_25 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_25),
      expression: "je_25"
    }],
    domProps: {
      "value": (_vm.je_25)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_25 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_25),
      expression: "se_25"
    }],
    domProps: {
      "value": (_vm.se_25)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_25 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("本期认证相符且本期未申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("26")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_26),
      expression: "fs_26"
    }],
    domProps: {
      "value": (_vm.fs_26)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_26 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_26),
      expression: "je_26"
    }],
    domProps: {
      "value": (_vm.je_26)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_26 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_26),
      expression: "se_26"
    }],
    domProps: {
      "value": (_vm.se_26)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_26 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("期末已认证相符但未申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("27")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_27),
      expression: "fs_27"
    }],
    domProps: {
      "value": (_vm.fs_27)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_27 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_27),
      expression: "je_27"
    }],
    domProps: {
      "value": (_vm.je_27)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_27 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_27),
      expression: "se_27"
    }],
    domProps: {
      "value": (_vm.se_27)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_27 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：按照税法规定不允许抵扣")]), _vm._v(" "), _c('td', [_vm._v("28")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_28),
      expression: "fs_28"
    }],
    domProps: {
      "value": (_vm.fs_28)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_28 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_28),
      expression: "je_28"
    }],
    domProps: {
      "value": (_vm.je_28)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_28 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_28),
      expression: "se_28"
    }],
    domProps: {
      "value": (_vm.se_28)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_28 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（二）其他扣税凭证")]), _vm._v(" "), _c('td', [_vm._v("29=30至33之和")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_29),
      expression: "fs_29"
    }],
    domProps: {
      "value": (_vm.fs_29)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_29 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_29),
      expression: "je_29"
    }],
    domProps: {
      "value": (_vm.je_29)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_29 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_29),
      expression: "se_29"
    }],
    domProps: {
      "value": (_vm.se_29)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_29 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：海关进口增值税专用缴款书")]), _vm._v(" "), _c('td', [_vm._v("30")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_30),
      expression: "fs_30"
    }],
    domProps: {
      "value": (_vm.fs_30)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_30 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_30),
      expression: "je_30"
    }],
    domProps: {
      "value": (_vm.je_30)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_30 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_30),
      expression: "se_30"
    }],
    domProps: {
      "value": (_vm.se_30)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_30 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("农产品收购发票或者销售发票")]), _vm._v(" "), _c('td', [_vm._v("31")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_31),
      expression: "fs_31"
    }],
    domProps: {
      "value": (_vm.fs_31)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_31 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_31),
      expression: "je_31"
    }],
    domProps: {
      "value": (_vm.je_31)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_31 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_31),
      expression: "se_31"
    }],
    domProps: {
      "value": (_vm.se_31)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_31 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("代扣代缴税收缴款凭证")]), _vm._v(" "), _c('td', [_vm._v("32")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_32),
      expression: "fs_32"
    }],
    domProps: {
      "value": (_vm.fs_32)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_32 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_32),
      expression: "je_32"
    }],
    domProps: {
      "value": (_vm.je_32)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_32 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_32),
      expression: "se_32"
    }],
    domProps: {
      "value": (_vm.se_32)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_32 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他")]), _vm._v(" "), _c('td', [_vm._v("33")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_33),
      expression: "fs_33"
    }],
    domProps: {
      "value": (_vm.fs_33)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_33 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_33),
      expression: "je_33"
    }],
    domProps: {
      "value": (_vm.je_33)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_33 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_33),
      expression: "se_33"
    }],
    domProps: {
      "value": (_vm.se_33)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_33 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("34")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_34),
      expression: "fs_34"
    }],
    domProps: {
      "value": (_vm.fs_34)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_34 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_34),
      expression: "je_34"
    }],
    domProps: {
      "value": (_vm.je_34)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_34 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_34),
      expression: "se_34"
    }],
    domProps: {
      "value": (_vm.se_34)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_34 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('tr', [_c('td', [_vm._v("本期认证相符的增值税专用发票")]), _vm._v(" "), _c('td', [_vm._v("35")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_35),
      expression: "fs_35"
    }],
    domProps: {
      "value": (_vm.fs_35)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_35 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_35),
      expression: "je_35"
    }],
    domProps: {
      "value": (_vm.je_35)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_35 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_35),
      expression: "se_35"
    }],
    domProps: {
      "value": (_vm.se_35)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_35 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("代扣代缴税额")]), _vm._v(" "), _c('td', [_vm._v("36")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_36),
      expression: "fs_36"
    }],
    domProps: {
      "value": (_vm.fs_36)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_36 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_36),
      expression: "je_36"
    }],
    domProps: {
      "value": (_vm.je_36)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_36 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_36),
      expression: "se_36"
    }],
    domProps: {
      "value": (_vm.se_36)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_36 = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("增值税纳税申报表附列资料（二）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("（本期进项税额明细）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("税款所属时间： 年 月 日 至 年 月 日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("纳税人名称：（公章）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("金额单位：元至角分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("一、申报抵扣的进项税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("栏次")]), _vm._v(" "), _c('td', [_vm._v("份数")]), _vm._v(" "), _c('td', [_vm._v("金额")]), _vm._v(" "), _c('td', [_vm._v("税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("二、进项税额转出额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("栏次")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("三、待抵扣进项税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("栏次")]), _vm._v(" "), _c('td', [_vm._v("份数")]), _vm._v(" "), _c('td', [_vm._v("金额")]), _vm._v(" "), _c('td', [_vm._v("税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("四、其他")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("栏次")]), _vm._v(" "), _c('td', [_vm._v("份数")]), _vm._v(" "), _c('td', [_vm._v("金额")]), _vm._v(" "), _c('td', [_vm._v("税额")])])
}]}

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "tftable",
    attrs: {
      "id": "tfhover",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "7"
    }
  }, [_vm._v("一、一般计税方法计税")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("全部征税项目")]), _vm._v(" "), _c('td', [_vm._v("13%税率的货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_1),
      expression: "A_1_1"
    }],
    domProps: {
      "value": (_vm.A_1_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_2),
      expression: "A_1_2"
    }],
    domProps: {
      "value": (_vm.A_1_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_3),
      expression: "A_1_3"
    }],
    domProps: {
      "value": (_vm.A_1_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_4),
      expression: "A_1_4"
    }],
    domProps: {
      "value": (_vm.A_1_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_5),
      expression: "A_1_5"
    }],
    domProps: {
      "value": (_vm.A_1_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_6),
      expression: "A_1_6"
    }],
    domProps: {
      "value": (_vm.A_1_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_7),
      expression: "A_1_7"
    }],
    domProps: {
      "value": (_vm.A_1_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_8),
      expression: "A_1_8"
    }],
    domProps: {
      "value": (_vm.A_1_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_9),
      expression: "A_1_9"
    }],
    domProps: {
      "value": (_vm.A_1_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_10),
      expression: "A_1_10"
    }],
    domProps: {
      "value": (_vm.A_1_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_11),
      expression: "A_1_11"
    }],
    domProps: {
      "value": (_vm.A_1_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_12),
      expression: "A_1_12"
    }],
    domProps: {
      "value": (_vm.A_1_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_13),
      expression: "A_1_13"
    }],
    domProps: {
      "value": (_vm.A_1_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_14),
      expression: "A_1_14"
    }],
    domProps: {
      "value": (_vm.A_1_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("13%税率的服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_1),
      expression: "A_2_1"
    }],
    domProps: {
      "value": (_vm.A_2_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_2),
      expression: "A_2_2"
    }],
    domProps: {
      "value": (_vm.A_2_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_3),
      expression: "A_2_3"
    }],
    domProps: {
      "value": (_vm.A_2_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_4),
      expression: "A_2_4"
    }],
    domProps: {
      "value": (_vm.A_2_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_5),
      expression: "A_2_5"
    }],
    domProps: {
      "value": (_vm.A_2_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_6),
      expression: "A_2_6"
    }],
    domProps: {
      "value": (_vm.A_2_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_7),
      expression: "A_2_7"
    }],
    domProps: {
      "value": (_vm.A_2_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_8),
      expression: "A_2_8"
    }],
    domProps: {
      "value": (_vm.A_2_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_9),
      expression: "A_2_9"
    }],
    domProps: {
      "value": (_vm.A_2_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_10),
      expression: "A_2_10"
    }],
    domProps: {
      "value": (_vm.A_2_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_11),
      expression: "A_2_11"
    }],
    domProps: {
      "value": (_vm.A_2_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_12),
      expression: "A_2_12"
    }],
    domProps: {
      "value": (_vm.A_2_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_13),
      expression: "A_2_13"
    }],
    domProps: {
      "value": (_vm.A_2_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_14),
      expression: "A_2_14"
    }],
    domProps: {
      "value": (_vm.A_2_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9%税率的货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_1),
      expression: "A_3_1"
    }],
    domProps: {
      "value": (_vm.A_3_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_2),
      expression: "A_3_2"
    }],
    domProps: {
      "value": (_vm.A_3_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_3),
      expression: "A_3_3"
    }],
    domProps: {
      "value": (_vm.A_3_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_4),
      expression: "A_3_4"
    }],
    domProps: {
      "value": (_vm.A_3_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_5),
      expression: "A_3_5"
    }],
    domProps: {
      "value": (_vm.A_3_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_6),
      expression: "A_3_6"
    }],
    domProps: {
      "value": (_vm.A_3_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_7),
      expression: "A_3_7"
    }],
    domProps: {
      "value": (_vm.A_3_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_8),
      expression: "A_3_8"
    }],
    domProps: {
      "value": (_vm.A_3_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_9),
      expression: "A_3_9"
    }],
    domProps: {
      "value": (_vm.A_3_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_10),
      expression: "A_3_10"
    }],
    domProps: {
      "value": (_vm.A_3_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_11),
      expression: "A_3_11"
    }],
    domProps: {
      "value": (_vm.A_3_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_12),
      expression: "A_3_12"
    }],
    domProps: {
      "value": (_vm.A_3_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_13),
      expression: "A_3_13"
    }],
    domProps: {
      "value": (_vm.A_3_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_14),
      expression: "A_3_14"
    }],
    domProps: {
      "value": (_vm.A_3_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9%税率的服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_1),
      expression: "A_4_1"
    }],
    domProps: {
      "value": (_vm.A_4_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_2),
      expression: "A_4_2"
    }],
    domProps: {
      "value": (_vm.A_4_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_3),
      expression: "A_4_3"
    }],
    domProps: {
      "value": (_vm.A_4_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_4),
      expression: "A_4_4"
    }],
    domProps: {
      "value": (_vm.A_4_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_5),
      expression: "A_4_5"
    }],
    domProps: {
      "value": (_vm.A_4_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_6),
      expression: "A_4_6"
    }],
    domProps: {
      "value": (_vm.A_4_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_7),
      expression: "A_4_7"
    }],
    domProps: {
      "value": (_vm.A_4_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_8),
      expression: "A_4_8"
    }],
    domProps: {
      "value": (_vm.A_4_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_9),
      expression: "A_4_9"
    }],
    domProps: {
      "value": (_vm.A_4_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_10),
      expression: "A_4_10"
    }],
    domProps: {
      "value": (_vm.A_4_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_11),
      expression: "A_4_11"
    }],
    domProps: {
      "value": (_vm.A_4_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_12),
      expression: "A_4_12"
    }],
    domProps: {
      "value": (_vm.A_4_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_13),
      expression: "A_4_13"
    }],
    domProps: {
      "value": (_vm.A_4_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_14),
      expression: "A_4_14"
    }],
    domProps: {
      "value": (_vm.A_4_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6%税率")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_1),
      expression: "A_5_1"
    }],
    domProps: {
      "value": (_vm.A_5_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_2),
      expression: "A_5_2"
    }],
    domProps: {
      "value": (_vm.A_5_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_3),
      expression: "A_5_3"
    }],
    domProps: {
      "value": (_vm.A_5_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_4),
      expression: "A_5_4"
    }],
    domProps: {
      "value": (_vm.A_5_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_5),
      expression: "A_5_5"
    }],
    domProps: {
      "value": (_vm.A_5_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_6),
      expression: "A_5_6"
    }],
    domProps: {
      "value": (_vm.A_5_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_7),
      expression: "A_5_7"
    }],
    domProps: {
      "value": (_vm.A_5_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_8),
      expression: "A_5_8"
    }],
    domProps: {
      "value": (_vm.A_5_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_9),
      expression: "A_5_9"
    }],
    domProps: {
      "value": (_vm.A_5_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_10),
      expression: "A_5_10"
    }],
    domProps: {
      "value": (_vm.A_5_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_11),
      expression: "A_5_11"
    }],
    domProps: {
      "value": (_vm.A_5_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_12),
      expression: "A_5_12"
    }],
    domProps: {
      "value": (_vm.A_5_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_13),
      expression: "A_5_13"
    }],
    domProps: {
      "value": (_vm.A_5_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_14),
      expression: "A_5_14"
    }],
    domProps: {
      "value": (_vm.A_5_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("其中：即征即退项目")]), _vm._v(" "), _c('td', [_vm._v("即征即退货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_1),
      expression: "A_6_1"
    }],
    domProps: {
      "value": (_vm.A_6_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_2),
      expression: "A_6_2"
    }],
    domProps: {
      "value": (_vm.A_6_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_3),
      expression: "A_6_3"
    }],
    domProps: {
      "value": (_vm.A_6_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_4),
      expression: "A_6_4"
    }],
    domProps: {
      "value": (_vm.A_6_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_5),
      expression: "A_6_5"
    }],
    domProps: {
      "value": (_vm.A_6_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_6),
      expression: "A_6_6"
    }],
    domProps: {
      "value": (_vm.A_6_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_7),
      expression: "A_6_7"
    }],
    domProps: {
      "value": (_vm.A_6_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_8),
      expression: "A_6_8"
    }],
    domProps: {
      "value": (_vm.A_6_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_9),
      expression: "A_6_9"
    }],
    domProps: {
      "value": (_vm.A_6_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_10),
      expression: "A_6_10"
    }],
    domProps: {
      "value": (_vm.A_6_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_11),
      expression: "A_6_11"
    }],
    domProps: {
      "value": (_vm.A_6_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_12),
      expression: "A_6_12"
    }],
    domProps: {
      "value": (_vm.A_6_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_13),
      expression: "A_6_13"
    }],
    domProps: {
      "value": (_vm.A_6_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_14),
      expression: "A_6_14"
    }],
    domProps: {
      "value": (_vm.A_6_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("即征即退服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_1),
      expression: "A_7_1"
    }],
    domProps: {
      "value": (_vm.A_7_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_2),
      expression: "A_7_2"
    }],
    domProps: {
      "value": (_vm.A_7_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_3),
      expression: "A_7_3"
    }],
    domProps: {
      "value": (_vm.A_7_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_4),
      expression: "A_7_4"
    }],
    domProps: {
      "value": (_vm.A_7_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_5),
      expression: "A_7_5"
    }],
    domProps: {
      "value": (_vm.A_7_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_6),
      expression: "A_7_6"
    }],
    domProps: {
      "value": (_vm.A_7_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_7),
      expression: "A_7_7"
    }],
    domProps: {
      "value": (_vm.A_7_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_8),
      expression: "A_7_8"
    }],
    domProps: {
      "value": (_vm.A_7_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_9),
      expression: "A_7_9"
    }],
    domProps: {
      "value": (_vm.A_7_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_10),
      expression: "A_7_10"
    }],
    domProps: {
      "value": (_vm.A_7_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_11),
      expression: "A_7_11"
    }],
    domProps: {
      "value": (_vm.A_7_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_12),
      expression: "A_7_12"
    }],
    domProps: {
      "value": (_vm.A_7_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_13),
      expression: "A_7_13"
    }],
    domProps: {
      "value": (_vm.A_7_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_14),
      expression: "A_7_14"
    }],
    domProps: {
      "value": (_vm.A_7_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "11"
    }
  }, [_vm._v("二、简易计税方法计税")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "9"
    }
  }, [_vm._v("全部征税项目")]), _vm._v(" "), _c('td', [_vm._v("6%征收率")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_1),
      expression: "A_8_1"
    }],
    domProps: {
      "value": (_vm.A_8_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_2),
      expression: "A_8_2"
    }],
    domProps: {
      "value": (_vm.A_8_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_3),
      expression: "A_8_3"
    }],
    domProps: {
      "value": (_vm.A_8_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_4),
      expression: "A_8_4"
    }],
    domProps: {
      "value": (_vm.A_8_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_5),
      expression: "A_8_5"
    }],
    domProps: {
      "value": (_vm.A_8_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_6),
      expression: "A_8_6"
    }],
    domProps: {
      "value": (_vm.A_8_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_7),
      expression: "A_8_7"
    }],
    domProps: {
      "value": (_vm.A_8_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_8),
      expression: "A_8_8"
    }],
    domProps: {
      "value": (_vm.A_8_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_9),
      expression: "A_8_9"
    }],
    domProps: {
      "value": (_vm.A_8_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_10),
      expression: "A_8_10"
    }],
    domProps: {
      "value": (_vm.A_8_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_11),
      expression: "A_8_11"
    }],
    domProps: {
      "value": (_vm.A_8_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_12),
      expression: "A_8_12"
    }],
    domProps: {
      "value": (_vm.A_8_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_13),
      expression: "A_8_13"
    }],
    domProps: {
      "value": (_vm.A_8_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_14),
      expression: "A_8_14"
    }],
    domProps: {
      "value": (_vm.A_8_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5%征收率的货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("9a")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_1),
      expression: "A_9a_1"
    }],
    domProps: {
      "value": (_vm.A_9a_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_2),
      expression: "A_9a_2"
    }],
    domProps: {
      "value": (_vm.A_9a_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_3),
      expression: "A_9a_3"
    }],
    domProps: {
      "value": (_vm.A_9a_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_4),
      expression: "A_9a_4"
    }],
    domProps: {
      "value": (_vm.A_9a_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_5),
      expression: "A_9a_5"
    }],
    domProps: {
      "value": (_vm.A_9a_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_6),
      expression: "A_9a_6"
    }],
    domProps: {
      "value": (_vm.A_9a_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_7),
      expression: "A_9a_7"
    }],
    domProps: {
      "value": (_vm.A_9a_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_8),
      expression: "A_9a_8"
    }],
    domProps: {
      "value": (_vm.A_9a_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_9),
      expression: "A_9a_9"
    }],
    domProps: {
      "value": (_vm.A_9a_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_10),
      expression: "A_9a_10"
    }],
    domProps: {
      "value": (_vm.A_9a_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_11),
      expression: "A_9a_11"
    }],
    domProps: {
      "value": (_vm.A_9a_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_12),
      expression: "A_9a_12"
    }],
    domProps: {
      "value": (_vm.A_9a_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_13),
      expression: "A_9a_13"
    }],
    domProps: {
      "value": (_vm.A_9a_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9a_14),
      expression: "A_9a_14"
    }],
    domProps: {
      "value": (_vm.A_9a_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9a_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5%征收率的服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("9b")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_1),
      expression: "A_9b_1"
    }],
    domProps: {
      "value": (_vm.A_9b_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_2),
      expression: "A_9b_2"
    }],
    domProps: {
      "value": (_vm.A_9b_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_3),
      expression: "A_9b_3"
    }],
    domProps: {
      "value": (_vm.A_9b_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_4),
      expression: "A_9b_4"
    }],
    domProps: {
      "value": (_vm.A_9b_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_5),
      expression: "A_9b_5"
    }],
    domProps: {
      "value": (_vm.A_9b_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_6),
      expression: "A_9b_6"
    }],
    domProps: {
      "value": (_vm.A_9b_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_7),
      expression: "A_9b_7"
    }],
    domProps: {
      "value": (_vm.A_9b_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_8),
      expression: "A_9b_8"
    }],
    domProps: {
      "value": (_vm.A_9b_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_9),
      expression: "A_9b_9"
    }],
    domProps: {
      "value": (_vm.A_9b_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_10),
      expression: "A_9b_10"
    }],
    domProps: {
      "value": (_vm.A_9b_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_11),
      expression: "A_9b_11"
    }],
    domProps: {
      "value": (_vm.A_9b_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_12),
      expression: "A_9b_12"
    }],
    domProps: {
      "value": (_vm.A_9b_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_13),
      expression: "A_9b_13"
    }],
    domProps: {
      "value": (_vm.A_9b_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_9b_14),
      expression: "A_9b_14"
    }],
    domProps: {
      "value": (_vm.A_9b_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_9b_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4%征收率")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_1),
      expression: "A_10_1"
    }],
    domProps: {
      "value": (_vm.A_10_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_2),
      expression: "A_10_2"
    }],
    domProps: {
      "value": (_vm.A_10_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_3),
      expression: "A_10_3"
    }],
    domProps: {
      "value": (_vm.A_10_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_4),
      expression: "A_10_4"
    }],
    domProps: {
      "value": (_vm.A_10_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_5),
      expression: "A_10_5"
    }],
    domProps: {
      "value": (_vm.A_10_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_6),
      expression: "A_10_6"
    }],
    domProps: {
      "value": (_vm.A_10_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_7),
      expression: "A_10_7"
    }],
    domProps: {
      "value": (_vm.A_10_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_8),
      expression: "A_10_8"
    }],
    domProps: {
      "value": (_vm.A_10_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_9),
      expression: "A_10_9"
    }],
    domProps: {
      "value": (_vm.A_10_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_10),
      expression: "A_10_10"
    }],
    domProps: {
      "value": (_vm.A_10_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_11),
      expression: "A_10_11"
    }],
    domProps: {
      "value": (_vm.A_10_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_12),
      expression: "A_10_12"
    }],
    domProps: {
      "value": (_vm.A_10_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_13),
      expression: "A_10_13"
    }],
    domProps: {
      "value": (_vm.A_10_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_10_14),
      expression: "A_10_14"
    }],
    domProps: {
      "value": (_vm.A_10_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_10_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3%征收率的货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("11")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_1),
      expression: "A_11_1"
    }],
    domProps: {
      "value": (_vm.A_11_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_2),
      expression: "A_11_2"
    }],
    domProps: {
      "value": (_vm.A_11_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_3),
      expression: "A_11_3"
    }],
    domProps: {
      "value": (_vm.A_11_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_4),
      expression: "A_11_4"
    }],
    domProps: {
      "value": (_vm.A_11_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_5),
      expression: "A_11_5"
    }],
    domProps: {
      "value": (_vm.A_11_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_6),
      expression: "A_11_6"
    }],
    domProps: {
      "value": (_vm.A_11_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_7),
      expression: "A_11_7"
    }],
    domProps: {
      "value": (_vm.A_11_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_8),
      expression: "A_11_8"
    }],
    domProps: {
      "value": (_vm.A_11_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_9),
      expression: "A_11_9"
    }],
    domProps: {
      "value": (_vm.A_11_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_10),
      expression: "A_11_10"
    }],
    domProps: {
      "value": (_vm.A_11_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_11),
      expression: "A_11_11"
    }],
    domProps: {
      "value": (_vm.A_11_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_12),
      expression: "A_11_12"
    }],
    domProps: {
      "value": (_vm.A_11_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_13),
      expression: "A_11_13"
    }],
    domProps: {
      "value": (_vm.A_11_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_11_14),
      expression: "A_11_14"
    }],
    domProps: {
      "value": (_vm.A_11_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_11_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3%征收率的服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("12")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_1),
      expression: "A_12_1"
    }],
    domProps: {
      "value": (_vm.A_12_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_2),
      expression: "A_12_2"
    }],
    domProps: {
      "value": (_vm.A_12_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_3),
      expression: "A_12_3"
    }],
    domProps: {
      "value": (_vm.A_12_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_4),
      expression: "A_12_4"
    }],
    domProps: {
      "value": (_vm.A_12_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_5),
      expression: "A_12_5"
    }],
    domProps: {
      "value": (_vm.A_12_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_6),
      expression: "A_12_6"
    }],
    domProps: {
      "value": (_vm.A_12_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_7),
      expression: "A_12_7"
    }],
    domProps: {
      "value": (_vm.A_12_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_8),
      expression: "A_12_8"
    }],
    domProps: {
      "value": (_vm.A_12_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_9),
      expression: "A_12_9"
    }],
    domProps: {
      "value": (_vm.A_12_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_10),
      expression: "A_12_10"
    }],
    domProps: {
      "value": (_vm.A_12_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_11),
      expression: "A_12_11"
    }],
    domProps: {
      "value": (_vm.A_12_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_12),
      expression: "A_12_12"
    }],
    domProps: {
      "value": (_vm.A_12_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_13),
      expression: "A_12_13"
    }],
    domProps: {
      "value": (_vm.A_12_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_12_14),
      expression: "A_12_14"
    }],
    domProps: {
      "value": (_vm.A_12_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_12_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("预征率 %")]), _vm._v(" "), _c('td', [_vm._v("13a")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_1),
      expression: "A_13a_1"
    }],
    domProps: {
      "value": (_vm.A_13a_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_2),
      expression: "A_13a_2"
    }],
    domProps: {
      "value": (_vm.A_13a_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_3),
      expression: "A_13a_3"
    }],
    domProps: {
      "value": (_vm.A_13a_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_4),
      expression: "A_13a_4"
    }],
    domProps: {
      "value": (_vm.A_13a_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_5),
      expression: "A_13a_5"
    }],
    domProps: {
      "value": (_vm.A_13a_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_6),
      expression: "A_13a_6"
    }],
    domProps: {
      "value": (_vm.A_13a_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_7),
      expression: "A_13a_7"
    }],
    domProps: {
      "value": (_vm.A_13a_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_8),
      expression: "A_13a_8"
    }],
    domProps: {
      "value": (_vm.A_13a_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_9),
      expression: "A_13a_9"
    }],
    domProps: {
      "value": (_vm.A_13a_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_10),
      expression: "A_13a_10"
    }],
    domProps: {
      "value": (_vm.A_13a_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_11),
      expression: "A_13a_11"
    }],
    domProps: {
      "value": (_vm.A_13a_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_12),
      expression: "A_13a_12"
    }],
    domProps: {
      "value": (_vm.A_13a_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_13),
      expression: "A_13a_13"
    }],
    domProps: {
      "value": (_vm.A_13a_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13a_14),
      expression: "A_13a_14"
    }],
    domProps: {
      "value": (_vm.A_13a_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13a_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("预征率 %")]), _vm._v(" "), _c('td', [_vm._v("13b")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_1),
      expression: "A_13b_1"
    }],
    domProps: {
      "value": (_vm.A_13b_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_2),
      expression: "A_13b_2"
    }],
    domProps: {
      "value": (_vm.A_13b_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_3),
      expression: "A_13b_3"
    }],
    domProps: {
      "value": (_vm.A_13b_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_4),
      expression: "A_13b_4"
    }],
    domProps: {
      "value": (_vm.A_13b_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_5),
      expression: "A_13b_5"
    }],
    domProps: {
      "value": (_vm.A_13b_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_6),
      expression: "A_13b_6"
    }],
    domProps: {
      "value": (_vm.A_13b_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_7),
      expression: "A_13b_7"
    }],
    domProps: {
      "value": (_vm.A_13b_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_8),
      expression: "A_13b_8"
    }],
    domProps: {
      "value": (_vm.A_13b_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_9),
      expression: "A_13b_9"
    }],
    domProps: {
      "value": (_vm.A_13b_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_10),
      expression: "A_13b_10"
    }],
    domProps: {
      "value": (_vm.A_13b_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_11),
      expression: "A_13b_11"
    }],
    domProps: {
      "value": (_vm.A_13b_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_12),
      expression: "A_13b_12"
    }],
    domProps: {
      "value": (_vm.A_13b_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_13),
      expression: "A_13b_13"
    }],
    domProps: {
      "value": (_vm.A_13b_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13b_14),
      expression: "A_13b_14"
    }],
    domProps: {
      "value": (_vm.A_13b_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13b_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("预征率 %")]), _vm._v(" "), _c('td', [_vm._v("13c")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_1),
      expression: "A_13c_1"
    }],
    domProps: {
      "value": (_vm.A_13c_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_2),
      expression: "A_13c_2"
    }],
    domProps: {
      "value": (_vm.A_13c_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_3),
      expression: "A_13c_3"
    }],
    domProps: {
      "value": (_vm.A_13c_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_4),
      expression: "A_13c_4"
    }],
    domProps: {
      "value": (_vm.A_13c_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_5),
      expression: "A_13c_5"
    }],
    domProps: {
      "value": (_vm.A_13c_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_6),
      expression: "A_13c_6"
    }],
    domProps: {
      "value": (_vm.A_13c_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_7),
      expression: "A_13c_7"
    }],
    domProps: {
      "value": (_vm.A_13c_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_8),
      expression: "A_13c_8"
    }],
    domProps: {
      "value": (_vm.A_13c_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_9),
      expression: "A_13c_9"
    }],
    domProps: {
      "value": (_vm.A_13c_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_10),
      expression: "A_13c_10"
    }],
    domProps: {
      "value": (_vm.A_13c_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_11),
      expression: "A_13c_11"
    }],
    domProps: {
      "value": (_vm.A_13c_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_12),
      expression: "A_13c_12"
    }],
    domProps: {
      "value": (_vm.A_13c_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_13),
      expression: "A_13c_13"
    }],
    domProps: {
      "value": (_vm.A_13c_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_13c_14),
      expression: "A_13c_14"
    }],
    domProps: {
      "value": (_vm.A_13c_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_13c_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("其中：即征即退项目")]), _vm._v(" "), _c('td', [_vm._v("即征即退货物及加工修理修配劳务")]), _vm._v(" "), _c('td', [_vm._v("14")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_1),
      expression: "A_14_1"
    }],
    domProps: {
      "value": (_vm.A_14_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_2),
      expression: "A_14_2"
    }],
    domProps: {
      "value": (_vm.A_14_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_3),
      expression: "A_14_3"
    }],
    domProps: {
      "value": (_vm.A_14_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_4),
      expression: "A_14_4"
    }],
    domProps: {
      "value": (_vm.A_14_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_5),
      expression: "A_14_5"
    }],
    domProps: {
      "value": (_vm.A_14_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_6),
      expression: "A_14_6"
    }],
    domProps: {
      "value": (_vm.A_14_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_7),
      expression: "A_14_7"
    }],
    domProps: {
      "value": (_vm.A_14_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_8),
      expression: "A_14_8"
    }],
    domProps: {
      "value": (_vm.A_14_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_9),
      expression: "A_14_9"
    }],
    domProps: {
      "value": (_vm.A_14_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_10),
      expression: "A_14_10"
    }],
    domProps: {
      "value": (_vm.A_14_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_11),
      expression: "A_14_11"
    }],
    domProps: {
      "value": (_vm.A_14_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_12),
      expression: "A_14_12"
    }],
    domProps: {
      "value": (_vm.A_14_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_13),
      expression: "A_14_13"
    }],
    domProps: {
      "value": (_vm.A_14_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_14_14),
      expression: "A_14_14"
    }],
    domProps: {
      "value": (_vm.A_14_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_14_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("即征即退服务、不动产和无形资产")]), _vm._v(" "), _c('td', [_vm._v("15")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_1),
      expression: "A_15_1"
    }],
    domProps: {
      "value": (_vm.A_15_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_2),
      expression: "A_15_2"
    }],
    domProps: {
      "value": (_vm.A_15_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_3),
      expression: "A_15_3"
    }],
    domProps: {
      "value": (_vm.A_15_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_4),
      expression: "A_15_4"
    }],
    domProps: {
      "value": (_vm.A_15_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_5),
      expression: "A_15_5"
    }],
    domProps: {
      "value": (_vm.A_15_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_6),
      expression: "A_15_6"
    }],
    domProps: {
      "value": (_vm.A_15_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_7),
      expression: "A_15_7"
    }],
    domProps: {
      "value": (_vm.A_15_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_8),
      expression: "A_15_8"
    }],
    domProps: {
      "value": (_vm.A_15_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_9),
      expression: "A_15_9"
    }],
    domProps: {
      "value": (_vm.A_15_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_10),
      expression: "A_15_10"
    }],
    domProps: {
      "value": (_vm.A_15_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_11),
      expression: "A_15_11"
    }],
    domProps: {
      "value": (_vm.A_15_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_12),
      expression: "A_15_12"
    }],
    domProps: {
      "value": (_vm.A_15_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_13),
      expression: "A_15_13"
    }],
    domProps: {
      "value": (_vm.A_15_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_15_14),
      expression: "A_15_14"
    }],
    domProps: {
      "value": (_vm.A_15_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_15_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("三、免抵退税")]), _vm._v(" "), _c('td', [_vm._v("货物及加工修理修配劳务")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("16")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_1),
      expression: "A_16_1"
    }],
    domProps: {
      "value": (_vm.A_16_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_2),
      expression: "A_16_2"
    }],
    domProps: {
      "value": (_vm.A_16_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_3),
      expression: "A_16_3"
    }],
    domProps: {
      "value": (_vm.A_16_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_4),
      expression: "A_16_4"
    }],
    domProps: {
      "value": (_vm.A_16_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_5),
      expression: "A_16_5"
    }],
    domProps: {
      "value": (_vm.A_16_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_6),
      expression: "A_16_6"
    }],
    domProps: {
      "value": (_vm.A_16_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_7),
      expression: "A_16_7"
    }],
    domProps: {
      "value": (_vm.A_16_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_8),
      expression: "A_16_8"
    }],
    domProps: {
      "value": (_vm.A_16_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_9),
      expression: "A_16_9"
    }],
    domProps: {
      "value": (_vm.A_16_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_10),
      expression: "A_16_10"
    }],
    domProps: {
      "value": (_vm.A_16_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_11),
      expression: "A_16_11"
    }],
    domProps: {
      "value": (_vm.A_16_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_12),
      expression: "A_16_12"
    }],
    domProps: {
      "value": (_vm.A_16_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_13),
      expression: "A_16_13"
    }],
    domProps: {
      "value": (_vm.A_16_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_16_14),
      expression: "A_16_14"
    }],
    domProps: {
      "value": (_vm.A_16_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_16_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("服务、不动产和无形资产")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("17")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_1),
      expression: "A_17_1"
    }],
    domProps: {
      "value": (_vm.A_17_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_2),
      expression: "A_17_2"
    }],
    domProps: {
      "value": (_vm.A_17_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_3),
      expression: "A_17_3"
    }],
    domProps: {
      "value": (_vm.A_17_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_4),
      expression: "A_17_4"
    }],
    domProps: {
      "value": (_vm.A_17_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_5),
      expression: "A_17_5"
    }],
    domProps: {
      "value": (_vm.A_17_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_6),
      expression: "A_17_6"
    }],
    domProps: {
      "value": (_vm.A_17_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_7),
      expression: "A_17_7"
    }],
    domProps: {
      "value": (_vm.A_17_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_8),
      expression: "A_17_8"
    }],
    domProps: {
      "value": (_vm.A_17_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_9),
      expression: "A_17_9"
    }],
    domProps: {
      "value": (_vm.A_17_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_10),
      expression: "A_17_10"
    }],
    domProps: {
      "value": (_vm.A_17_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_11),
      expression: "A_17_11"
    }],
    domProps: {
      "value": (_vm.A_17_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_12),
      expression: "A_17_12"
    }],
    domProps: {
      "value": (_vm.A_17_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_13),
      expression: "A_17_13"
    }],
    domProps: {
      "value": (_vm.A_17_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_17_14),
      expression: "A_17_14"
    }],
    domProps: {
      "value": (_vm.A_17_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_17_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("四、免税")]), _vm._v(" "), _c('td', [_vm._v("货物及加工修理修配劳务")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("18")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_1),
      expression: "A_18_1"
    }],
    domProps: {
      "value": (_vm.A_18_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_2),
      expression: "A_18_2"
    }],
    domProps: {
      "value": (_vm.A_18_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_3),
      expression: "A_18_3"
    }],
    domProps: {
      "value": (_vm.A_18_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_4),
      expression: "A_18_4"
    }],
    domProps: {
      "value": (_vm.A_18_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_5),
      expression: "A_18_5"
    }],
    domProps: {
      "value": (_vm.A_18_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_6),
      expression: "A_18_6"
    }],
    domProps: {
      "value": (_vm.A_18_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_7),
      expression: "A_18_7"
    }],
    domProps: {
      "value": (_vm.A_18_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_8),
      expression: "A_18_8"
    }],
    domProps: {
      "value": (_vm.A_18_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_9),
      expression: "A_18_9"
    }],
    domProps: {
      "value": (_vm.A_18_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_10),
      expression: "A_18_10"
    }],
    domProps: {
      "value": (_vm.A_18_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_11),
      expression: "A_18_11"
    }],
    domProps: {
      "value": (_vm.A_18_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_12),
      expression: "A_18_12"
    }],
    domProps: {
      "value": (_vm.A_18_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_13),
      expression: "A_18_13"
    }],
    domProps: {
      "value": (_vm.A_18_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_18_14),
      expression: "A_18_14"
    }],
    domProps: {
      "value": (_vm.A_18_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_18_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("服务、不动产和无形资产")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("19")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_1),
      expression: "A_19_1"
    }],
    domProps: {
      "value": (_vm.A_19_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_2),
      expression: "A_19_2"
    }],
    domProps: {
      "value": (_vm.A_19_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_3),
      expression: "A_19_3"
    }],
    domProps: {
      "value": (_vm.A_19_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_4),
      expression: "A_19_4"
    }],
    domProps: {
      "value": (_vm.A_19_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_5),
      expression: "A_19_5"
    }],
    domProps: {
      "value": (_vm.A_19_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_6),
      expression: "A_19_6"
    }],
    domProps: {
      "value": (_vm.A_19_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_6 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_7),
      expression: "A_19_7"
    }],
    domProps: {
      "value": (_vm.A_19_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_8),
      expression: "A_19_8"
    }],
    domProps: {
      "value": (_vm.A_19_8)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_8 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_9),
      expression: "A_19_9"
    }],
    domProps: {
      "value": (_vm.A_19_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_10),
      expression: "A_19_10"
    }],
    domProps: {
      "value": (_vm.A_19_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_11),
      expression: "A_19_11"
    }],
    domProps: {
      "value": (_vm.A_19_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_12),
      expression: "A_19_12"
    }],
    domProps: {
      "value": (_vm.A_19_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_13),
      expression: "A_19_13"
    }],
    domProps: {
      "value": (_vm.A_19_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_19_14),
      expression: "A_19_14"
    }],
    domProps: {
      "value": (_vm.A_19_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_19_14 = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "18"
    }
  }, [_vm._v("增值税纳税申报表附列资料（一）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px"
    },
    attrs: {
      "colspan": "18"
    }
  }, [_vm._v("（本期销售情况明细）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "18"
    }
  }, [_vm._v("税款所属时间： 年 月 日 至 年 月 日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "18"
    }
  }, [_vm._v("纳税人名称：（公章）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "4"
    }
  }, [_vm._v("项目及栏次")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("开具其他发票")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("未开具发票")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("纳税检查调整")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("合计")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("服务、不动产和无形资产扣除项目本期实际扣除金额")]), _vm._v(" "), _c('td', [_vm._v("扣除后")]), _vm._v(" "), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("销售额")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("销售额")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("销售额")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("销售额")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("销售额 I（总销售收入销售额+纳税检查+视同销售）")]), _vm._v(" "), _c('td', [_vm._v("销项(应纳)税额")]), _vm._v(" "), _c('td', [_vm._v("价税合计")]), _vm._v(" "), _c('td', [_vm._v("13")]), _vm._v(" "), _c('td', [_vm._v("14")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("9=1+3+5+7")]), _vm._v(" "), _c('td', [_vm._v("10=2+4+6+8")]), _vm._v(" "), _c('td', [_vm._v("11=9+10")]), _vm._v(" "), _c('td', [_vm._v("12")]), _vm._v(" "), _c('td', [_vm._v("13=11-12")]), _vm._v(" "), _c('td', [_vm._v("14=13÷(100%+税率或征收率)×税率或征收率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("1、开具增值税专用发票、开具其他发票两个栏次根据1.1销项发票取数台账填写，区分发票类型（专票或普票）结合对应的申报行次填写。（包含免税开票情形）")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("2、根据总销售收入台账减去销项发票取数台账加上视同销售台账得到的金额，按照对应的申报表栏次填写未开具发票销售额及销项税额")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("3、纳税检查调整栏次根据1.3纳税检查调整台账中的数据，按照对应的申报表栏次填写")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("4.即征即退行次数据根据1.5即征即退管理台账的金额填写")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("5.服务、不动产和无形资产扣除项目本期实际扣除金额根据附表三的数据填写，具体公式已经在表格里")])])
}]}

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("开发中...")])])
}]}

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("page5...\n")])
},staticRenderFns: []}

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.collapsed ? '' : _vm.sysName) + "\n\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("我的消息")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("设置")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    style: ({
      width: _vm.collapsed ? '64px' : '270px'
    }),
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("page6...\n")])
},staticRenderFns: []}

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动区域"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择活动区域"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.$set(_vm.form, "region", $$v)
      },
      expression: "form.region"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "区域一",
      "value": "shanghai"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "区域二",
      "value": "beijing"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.date1),
      callback: function($$v) {
        _vm.$set(_vm.form, "date1", $$v)
      },
      expression: "form.date1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "fixed-time",
      "placeholder": "选择时间"
    },
    model: {
      value: (_vm.form.date2),
      callback: function($$v) {
        _vm.$set(_vm.form, "date2", $$v)
      },
      expression: "form.date2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "即时配送"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动性质"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "美食/餐厅线上活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "地推活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "线下主题活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "单纯品牌曝光",
      "name": "type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特殊资源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.resource),
      callback: function($$v) {
        _vm.$set(_vm.form, "resource", $$v)
      },
      expression: "form.resource"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "线上品牌商赞助"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "线下场地免费"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动形式"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "tb-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.aData,
      "highlight-current-row": "",
      "height": "550",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "销项涉税规则维护",
      "align": "center",
      "width": "180"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "id",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.companyCode),
            callback: function($$v) {
              _vm.$set(scope.row, "companyCode", $$v)
            },
            expression: "scope.row.companyCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.companyName),
            callback: function($$v) {
              _vm.$set(scope.row, "companyName", $$v)
            },
            expression: "scope.row.companyName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则编号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.code),
            callback: function($$v) {
              _vm.$set(scope.row, "code", $$v)
            },
            expression: "scope.row.code"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计税方式",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择计税方式"
          },
          model: {
            value: (scope.row.jsfs),
            callback: function($$v) {
              _vm.$set(scope.row, "jsfs", $$v)
            },
            expression: "scope.row.jsfs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "免税",
            "value": "免税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "一般计税",
            "value": "一般计税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "简易计税",
            "value": "简易计税"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.jsfs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否计税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否计税"
          },
          model: {
            value: (scope.row.sfjs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjs", $$v)
            },
            expression: "scope.row.sfjs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否含税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否含税"
          },
          model: {
            value: (scope.row.sfhs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfhs", $$v)
            },
            expression: "scope.row.sfhs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfhs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择税率"
          },
          model: {
            value: (scope.row.taxRate),
            callback: function($$v) {
              _vm.$set(scope.row, "taxRate", $$v)
            },
            expression: "scope.row.taxRate"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "0%",
            "value": "0%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "3%",
            "value": "3%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "6%",
            "value": "6%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "10%",
            "value": "10%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "16%",
            "value": "16%"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.taxRate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否即征即退",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否即征即退"
          },
          model: {
            value: (scope.row.sfjzjt),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjzjt", $$v)
            },
            expression: "scope.row.sfjzjt"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjzjt))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开票规则",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.kpgz),
            callback: function($$v) {
              _vm.$set(scope.row, "kpgz", $$v)
            },
            expression: "scope.row.kpgz"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.kpgz))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.goodsCode),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsCode", $$v)
            },
            expression: "scope.row.goodsCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.goodsName),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsName", $$v)
            },
            expression: "scope.row.goodsName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.rowIndex),
            callback: function($$v) {
              _vm.$set(scope.row, "rowIndex", $$v)
            },
            expression: "scope.row.rowIndex"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.rowIndex))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行名",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.tableName),
            callback: function($$v) {
              _vm.$set(scope.row, "tableName", $$v)
            },
            expression: "scope.row.tableName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.tableName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.isEnable),
            callback: function($$v) {
              _vm.$set(scope.row, "isEnable", $$v)
            },
            expression: "scope.row.isEnable"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.isEnable))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 723:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "tb-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.aData,
      "highlight-current-row": "",
      "height": "550",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "销项涉税规则维护",
      "align": "center",
      "width": "180"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "id",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.companyCode),
            callback: function($$v) {
              _vm.$set(scope.row, "companyCode", $$v)
            },
            expression: "scope.row.companyCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.companyName),
            callback: function($$v) {
              _vm.$set(scope.row, "companyName", $$v)
            },
            expression: "scope.row.companyName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则编号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.code),
            callback: function($$v) {
              _vm.$set(scope.row, "code", $$v)
            },
            expression: "scope.row.code"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计税方式",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择计税方式"
          },
          model: {
            value: (scope.row.jsfs),
            callback: function($$v) {
              _vm.$set(scope.row, "jsfs", $$v)
            },
            expression: "scope.row.jsfs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "免税",
            "value": "免税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "一般计税",
            "value": "一般计税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "简易计税",
            "value": "简易计税"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.jsfs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否计税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否计税"
          },
          model: {
            value: (scope.row.sfjs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjs", $$v)
            },
            expression: "scope.row.sfjs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否含税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否含税"
          },
          model: {
            value: (scope.row.sfhs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfhs", $$v)
            },
            expression: "scope.row.sfhs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfhs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择税率"
          },
          model: {
            value: (scope.row.taxRate),
            callback: function($$v) {
              _vm.$set(scope.row, "taxRate", $$v)
            },
            expression: "scope.row.taxRate"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "0%",
            "value": "0%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "3%",
            "value": "3%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "6%",
            "value": "6%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "10%",
            "value": "10%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "16%",
            "value": "16%"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.taxRate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否即征即退",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否即征即退"
          },
          model: {
            value: (scope.row.sfjzjt),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjzjt", $$v)
            },
            expression: "scope.row.sfjzjt"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjzjt))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开票规则",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.kpgz),
            callback: function($$v) {
              _vm.$set(scope.row, "kpgz", $$v)
            },
            expression: "scope.row.kpgz"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.kpgz))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.goodsCode),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsCode", $$v)
            },
            expression: "scope.row.goodsCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.goodsName),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsName", $$v)
            },
            expression: "scope.row.goodsName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.rowIndex),
            callback: function($$v) {
              _vm.$set(scope.row, "rowIndex", $$v)
            },
            expression: "scope.row.rowIndex"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.rowIndex))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行名",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.tableName),
            callback: function($$v) {
              _vm.$set(scope.row, "tableName", $$v)
            },
            expression: "scope.row.tableName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.tableName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.isEnable),
            callback: function($$v) {
              _vm.$set(scope.row, "isEnable", $$v)
            },
            expression: "scope.row.isEnable"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.isEnable))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "tb-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.aData,
      "highlight-current-row": "",
      "height": "550",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "销项涉税规则维护",
      "align": "center",
      "width": "180"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "id",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.companyCode),
            callback: function($$v) {
              _vm.$set(scope.row, "companyCode", $$v)
            },
            expression: "scope.row.companyCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.companyName),
            callback: function($$v) {
              _vm.$set(scope.row, "companyName", $$v)
            },
            expression: "scope.row.companyName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则编号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.code),
            callback: function($$v) {
              _vm.$set(scope.row, "code", $$v)
            },
            expression: "scope.row.code"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计税方式",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择计税方式"
          },
          model: {
            value: (scope.row.jsfs),
            callback: function($$v) {
              _vm.$set(scope.row, "jsfs", $$v)
            },
            expression: "scope.row.jsfs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "免税",
            "value": "免税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "一般计税",
            "value": "一般计税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "简易计税",
            "value": "简易计税"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.jsfs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否计税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否计税"
          },
          model: {
            value: (scope.row.sfjs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjs", $$v)
            },
            expression: "scope.row.sfjs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否含税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否含税"
          },
          model: {
            value: (scope.row.sfhs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfhs", $$v)
            },
            expression: "scope.row.sfhs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfhs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择税率"
          },
          model: {
            value: (scope.row.taxRate),
            callback: function($$v) {
              _vm.$set(scope.row, "taxRate", $$v)
            },
            expression: "scope.row.taxRate"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "0%",
            "value": "0%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "3%",
            "value": "3%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "6%",
            "value": "6%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "10%",
            "value": "10%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "16%",
            "value": "16%"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.taxRate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否即征即退",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否即征即退"
          },
          model: {
            value: (scope.row.sfjzjt),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjzjt", $$v)
            },
            expression: "scope.row.sfjzjt"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjzjt))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开票规则",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.kpgz),
            callback: function($$v) {
              _vm.$set(scope.row, "kpgz", $$v)
            },
            expression: "scope.row.kpgz"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.kpgz))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.goodsCode),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsCode", $$v)
            },
            expression: "scope.row.goodsCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.goodsName),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsName", $$v)
            },
            expression: "scope.row.goodsName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.rowIndex),
            callback: function($$v) {
              _vm.$set(scope.row, "rowIndex", $$v)
            },
            expression: "scope.row.rowIndex"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.rowIndex))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行名",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.tableName),
            callback: function($$v) {
              _vm.$set(scope.row, "tableName", $$v)
            },
            expression: "scope.row.tableName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.tableName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          on: {
            "change": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.isEnable),
            callback: function($$v) {
              _vm.$set(scope.row, "isEnable", $$v)
            },
            expression: "scope.row.isEnable"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.isEnable))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "公司名称"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "aTable",
    staticClass: "tb-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.aData,
      "highlight-current-row": "",
      "height": "550",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "销项涉税规则维护",
      "align": "center",
      "width": "180"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "id",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          style: ({
            color: _vm.getIdColor(scope.row.state)
          })
        }, [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.companyCode),
            callback: function($$v) {
              _vm.$set(scope.row, "companyCode", $$v)
            },
            expression: "scope.row.companyCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公司名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.companyName),
            callback: function($$v) {
              _vm.$set(scope.row, "companyName", $$v)
            },
            expression: "scope.row.companyName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.companyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则编号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.code),
            callback: function($$v) {
              _vm.$set(scope.row, "code", $$v)
            },
            expression: "scope.row.code"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "涉税规则名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计税方式",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择计税方式"
          },
          model: {
            value: (scope.row.jsfs),
            callback: function($$v) {
              _vm.$set(scope.row, "jsfs", $$v)
            },
            expression: "scope.row.jsfs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "免税",
            "value": "免税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "一般计税",
            "value": "一般计税"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "简易计税",
            "value": "简易计税"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.jsfs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否计税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否计税"
          },
          model: {
            value: (scope.row.sfjs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjs", $$v)
            },
            expression: "scope.row.sfjs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否含税",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否含税"
          },
          model: {
            value: (scope.row.sfhs),
            callback: function($$v) {
              _vm.$set(scope.row, "sfhs", $$v)
            },
            expression: "scope.row.sfhs"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfhs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择税率"
          },
          model: {
            value: (scope.row.taxRate),
            callback: function($$v) {
              _vm.$set(scope.row, "taxRate", $$v)
            },
            expression: "scope.row.taxRate"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "0%",
            "value": "0%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "3%",
            "value": "3%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "6%",
            "value": "6%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "10%",
            "value": "10%"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "16%",
            "value": "16%"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.taxRate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否即征即退",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否即征即退"
          },
          model: {
            value: (scope.row.sfjzjt),
            callback: function($$v) {
              _vm.$set(scope.row, "sfjzjt", $$v)
            },
            expression: "scope.row.sfjzjt"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sfjzjt))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开票规则",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择开票规则"
          },
          model: {
            value: (scope.row.kpgz),
            callback: function($$v) {
              _vm.$set(scope.row, "kpgz", $$v)
            },
            expression: "scope.row.kpgz"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "不开票",
            "value": "不开票"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "增值税专用发票",
            "value": "增值税专用发票"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "增值税普通发票",
            "value": "增值税普通发票"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.kpgz))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.goodsCode),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsCode", $$v)
            },
            expression: "scope.row.goodsCode"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品及服务名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.goodsName),
            callback: function($$v) {
              _vm.$set(scope.row, "goodsName", $$v)
            },
            expression: "scope.row.goodsName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.goodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.rowIndex),
            callback: function($$v) {
              _vm.$set(scope.row, "rowIndex", $$v)
            },
            expression: "scope.row.rowIndex"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.rowIndex))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "纳税申报表行名",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.tableName),
            callback: function($$v) {
              _vm.$set(scope.row, "tableName", $$v)
            },
            expression: "scope.row.tableName"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.tableName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择是否即征即退"
          },
          model: {
            value: (scope.row.isEnable),
            callback: function($$v) {
              _vm.$set(scope.row, "isEnable", $$v)
            },
            expression: "scope.row.isEnable"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "是",
            "value": "是"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "否",
            "value": "否"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.isEnable))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTableContainer"
  }, [_c('div', {
    staticClass: "table-nav"
  }, [_c('el-link', [_vm._v("xx 公司")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("主表")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("附表一")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("附表二")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("附表三")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("附表四")])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "tb-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mainTable,
      "span-method": _vm.objectSpanMethod,
      "border": "",
      "highlight-current-row": "",
      "row-class-name": _vm.rowClass
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "增 值 税 纳 税 申 报 表",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label-class-name": "font12",
      "label": "（一般纳税人适用）",
      "header-align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "left",
      "label-class-name": "font10 color999",
      "label": "    根据国家税收法律法规及增值税相关规定制定本表。纳税人不论有无销售额，均应按税务机关核定的纳税期限填写本表，并向当地税务机关申报。"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "项     目",
      "header-align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "40px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "width": "14px",
            "font-size": "14px",
            "word-wrap": "break-word",
            "letter-spacing": "20px"
          }
        }, [_vm._v(_vm._s(scope.row.itemType))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.titles && scope.row.titles.length > 0) ? _c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "right"
          }
        }, [_c('div', _vm._l((scope.row.titles), function(title) {
          return _c('p', {
            key: title
          }, [_vm._v(_vm._s(title))])
        }), 0), _vm._v(" "), _c('div', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('el-badge', {
          staticClass: "hasTitle",
          attrs: {
            "is-dot": ""
          }
        }, [_vm._v(_vm._s(scope.row.item))])], 1)]) : _c('div', {
          staticStyle: {
            "white-space": "pre"
          }
        }, [_vm._v(_vm._s(scope.row.item))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "栏次",
      "header-align": "center",
      "prop": "lc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "一般项目",
      "header-align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "本月数",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "disabled": _vm.isDisable(scope.row),
            "change": _vm.inputChange(scope.row, scope.row.a1),
            "placeholder": "请输入一般项目本月数"
          },
          model: {
            value: (scope.row.a1),
            callback: function($$v) {
              _vm.$set(scope.row, "a1", $$v)
            },
            expression: "scope.row.a1"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.a1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "本年累计",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "disabled": _vm.isDisable(scope.row),
            "change": _vm.inputChange(scope.row, scope.row.a1),
            "placeholder": "请输入一般项目本年累计"
          },
          model: {
            value: (scope.row.a2),
            callback: function($$v) {
              _vm.$set(scope.row, "a2", $$v)
            },
            expression: "scope.row.a2"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.a2))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "即征即退项目",
      "header-align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "本月数",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "disabled": _vm.isDisable(scope.row),
            "change": _vm.inputChange(scope.row, scope.row.a1),
            "placeholder": "请输入即征即退项目本月数"
          },
          model: {
            value: (scope.row.b1),
            callback: function($$v) {
              _vm.$set(scope.row, "b1", $$v)
            },
            expression: "scope.row.b1"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.b1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "本年累计",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "disabled": _vm.isDisable(scope.row),
            "change": _vm.inputChange(scope.row, scope.row.a1),
            "placeholder": "请输入即征即退项目本年累计"
          },
          model: {
            value: (scope.row.b2),
            callback: function($$v) {
              _vm.$set(scope.row, "b2", $$v)
            },
            expression: "scope.row.b2"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.b2))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "can-space"
  }, [_vm._v("主管税务机关： 接收人：")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUser
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "生日",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "地址",
      "min-width": "180",
      "sortable": ""
    }
  })], 1)]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartColumn"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartBar"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartPie"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "http://echarts.baidu.com/examples.html",
      "target": "_blank"
    }
  }, [_vm._v("more>>")])])], 1)], 1)
},staticRenderFns: []}

/***/ })

},[336]);


// WEBPACK FOOTER //
// static/js/app.6b94c97b7341bb787ff4.js